// TODO: refactor those imports in typescript
import i18n from '../../../utils/i18n'

import * as React from 'react'
import { formatCouponNameAsString } from '../../components/plugins/casting/coupon/casting-coupon-picker.component'
import { CouponPackBase } from '../json-schemas/base/coupon_pack'
import { EmployeeBase } from '../json-schemas/base/employee'
import { OfferedOptionBase } from '../json-schemas/base/offered_option'
import { OfferedServiceBase } from '../json-schemas/base/offered_service'
import { PrescriberBase } from '../json-schemas/base/prescriber'
import { PromotionalCodeBase } from '../json-schemas/base/promotional_code'
import { ServiceCategoryBase } from '../json-schemas/base/service_category'
import { SpecificPriceRuleBase } from '../json-schemas/base/specific_price_rule'
import { SupplierBase } from '../json-schemas/base/supplier'
import { SuppliersCastingsGetServiceResponse } from '../json-schemas/serializers/suppliers-castings-get-service-response'
import { SuppliersCustomerForCastingProps } from '../json-schemas/serializers/suppliers-customer-for-casting-props'
import { castingExtendsAllowedPatternOnDurationChanged, castingSimulateFirstEventsFromUnfinalizedCasting, CastingSlot, castingSlotAllowedPatternFirstDate, castingsSlotAllowingAnyTimeOn7Days, CastingType, castingUnserializeSlot, castingWeeksInterval } from '../models/castings.service'
import { UnsupportedPets } from '../models/employee-informations.service'
import { employeeIsDirectlyPaid, employeeIsAvailable, RansackQuery as EmployeeRansackQuery } from '../models/employees.service'
import { OfferedOptionOfferedServiceRequiredStatus } from '../models/offered-option-offered-services.service'
import { offeredServiceResourceIsAvailable } from '../models/offered-service-resources.service'
import { fullfilledMultiOpeningHours, InterventionPlace, MultiOpeningHours, WorkingDay } from '../models/offered-services.service'
import { websiteCastingWidgetPluginGetServices, websiteCastingWidgetPluginComputeCastingPricesForEvents, websiteCastingWidgetPluginOfferedService, websiteCastingWidgetPluginRealtimeAvailabilities, websiteCastingWidgetPluginLodgingValidateIcalUrl, websiteCastingWidgetPluginComputeCastingTotalPrice, websiteCastingWidgetPluginDataPreview, websiteCastingWidgetGetGroupSessionDates, websiteCastingWidgetGetGroupSessionsAtDay } from '../models/website-casting-widgets.service'
import { AsyncComputedProperty } from '../utils/async-computed-property.service'
import { currencyFormat, currencyWrapTaxNotice } from '../utils/currency.service'
import { getWindowHeight } from '../utils/dom.service'
import { geocodingGeodesicDistance } from '../utils/geocoding.service'
import { I18nService } from '../utils/i18n.service'
import { TypedID } from '../utils/iots.service'
import { toUpperCaseFirst, deepEqualLite, takeWhile, onlyUniqueByReference } from '../utils/lodash.service'
import { moment } from '../utils/moment.service'
import { Openable, openableDateToWorkingDay, openableFromCastingSlotAllowedPatterns, openableIntersection, openableOverMidnight, openableReduce, openableStartHours, openableUnserialize, UnserializedMultiOpeningHours } from '../utils/openables.service'
import { formatDurationFromSecs, formatTime, isSameDay, parseTime, truncateString, utilFormatWordsListWithLimit, utilGroupBy } from '../utils/utils.service'
import { boughtCouponsPackConsumptionInsights } from '../models/bought-coupons-packs.service'
import { WebsiteCastingWidgetShowResponse } from '../json-schemas/serializers/website-casting-widget-show-response'
import { QuotationBase } from '../json-schemas/base/quotation'
import { ItemQuotationBase } from '../json-schemas/base/item_quotation'
import { CesuMileageReimbursementBase } from '../json-schemas/base/cesu_mileage_reimbursement'
import { CesuQuotationBase } from '../json-schemas/base/cesu_quotation'
import { quotationReadyForSubmit } from '../models/quotations.service'
import { EmployeeInformationBase } from '../json-schemas/base/employee_information'
import { LodgingBase } from '../json-schemas/base/lodging'
import { AddressBase } from '../json-schemas/base/address'
import { CountriesData } from '../models/countries.service'
import { lodgingI18nIcalProvider } from '../models/lodgings.service'
import { InvitationBase } from '../json-schemas/base/invitation'
import { SelectedDurationCalculatorItemBase } from '../json-schemas/base/selected_duration_calculator_item'
import { SelectedQuantityDiscountBase } from '../json-schemas/base/selected_quantity_discount'
import { OfferedQuantityDiscountBase } from '../json-schemas/base/offered_quantity_discount'
import { offeredQuantityDiscountsI18nQuantityWithUnit } from '../models/offered-quantity-discounts.service'
import { CastingBase } from '../json-schemas/base/casting'
import { modalOpenAlert, modalOpenDecorated } from '../utils/modals.service'
import { SupplierCastingsGetGroupSessionsAtDay } from '../json-schemas/serializers/supplier-castings-get-group-sessions-at-day'
import { scheduleI18nIntervalFrequency } from '../models/schedules.service'
import { castingGeodingSendQuery } from '../utils/casting-geocoding.service'
import { CustomerPlanBase } from '../json-schemas/base/customer_plan'
import { formatCustomerPlanNameAsString } from '../../components/plugins/casting/customer-plan/casting-customer-plans.component'
import { CustomerBase } from '../json-schemas/base/customer'
import { CustomerPlanSubscriptionBase } from '../json-schemas/base/customer_plan_subscription'
import { customerPlanSubscriptionUpdateExpirationAction } from '../models/customer-plan-subscriptions.service'
import i18nScopedData from './casting.store.yml'

export interface StoreProps {
  data: CastingStore['data']
  store: CastingStore
}

export interface StartDayDisabledTracing {
  status: 'pass' | 'fail' | 'info'
  summary: string
}

export const alwaysCompletedFocusedInputs = [
  'coupon' as const,
  'message' as const,
  'preferences' as const,
  'tasks' as const,
  'end-of-step-1' as const,
  'price' as const,
  'participants' as const
]

export const focusedInputs = [
  'end-of-step-1',
  'end-of-step-2',
  'backoffice-customer',
  'backoffice-service-delivery',
  'backoffice-custom-price',
  'employee-quotation',
  'city',
  'offered-service',
  'enable-lodging',
  'required-place',
  'customer-plan',
  'coupon',
  'quantity-discount',
  'quantity',
  'combination-attributes',
  'combination-attributes-after-offered-service',
  'group-session',
  'complex-variant',
  'lodging',
  'lodging-ical',
  'lodging-check-in-out',
  'duration',
  'start-date',
  'complex',
  'frequency',
  'end-date',
  'backoffice-appointment',
  'options',
  'participants',
  'attachments',
  'preferences',
  'tasks',
  'message',
  'price'
] as const

const i18nScoped = new I18nService(i18nScopedData)

export class CastingStore {
  changeListeners: ((data: CastingStore['data'], oldData: CastingStore['data'], changes: (keyof CastingStore['data'])[]) => void)[] = [
    this.getRealTimeAvailabilities.bind(this)
  ]

  data: {
    editedCastingId: TypedID<'Casting'> | null

    /** frontoffice for base custom translations (e.g. casting_steps.step_2.inputs.participants_number_label) */
    frontofficeTranslations: Record<string, unknown>

    /** The step currently deployed */
    focusedInput: typeof focusedInputs[number]

    /** The last step opened, used for back navigation */
    lastFocusedInput: typeof focusedInputs[number]

    /** The casting can work on various configuration, implying various UI and UX changes */
    renderingMode: 'desktop' | 'mobile' | 'widget'
    
    /** For CreateEventWithCastingComponent, forces the operator choosing a customer as first step (enable 'backoffice-customer' step) */
    backofficeSelectCustomer: boolean

    /** For CreateEventWithCastingComponent, forces the operator to provide the service delivery address. */
    backofficeFillServiceDelivery: boolean

    /** For CreateEventWithCastingComponent, allows the operator to pick an offered_service with enable_group = true. Implies that the service_delivery address must be completed and the event will be immetially scheduled */
    backofficeAllowGroupSession: boolean

    /**
     * For CreateEventWithCastingComponent, forces the operator to choice for each slot:
     * - an available employee if service.
     * - an available resource if rentable product.
     * 
     * It reuses the 'complex' (with some customizing) unless offeredService.offeredService.rentable_unit_of_work === 'day'.
     * 
     * If market.employee_can_create_casting?, the employee may also control that field. In such case
     * and if current_user.employee?, this property will be initialized to null. Otherwise, it is false by default.
     * 
     * The slot duration is ajusted to match the [start, end] picked in the UI, so complex_duration_different_than_range is ignored.
     */
    backofficeSelectAssignableForSlots: boolean | null

    /**
     * If `backofficeSelectAssignableForSlots` is true, `backofficePreselectedEmployee` can be set during store init.
     * When set, the employee/resource is set by default for each slot.
     * In case `supplier.solo_edition_active?`, the assignable cannot be changed.
     */
    backofficePreselectedEmployee?: Pick<EmployeeBase, 'id' | 'name'> & { employee_information: Pick<EmployeeInformationBase, 'no_vat'> }

    /** For CreateEventWithCastingComponent, allow to start in the past */
    backofficeAllowToStartInPast: boolean

    /** Allow the operator to skip the waiting period when !backofficeAllowToStartInPast */
    backofficeSkipsWaitingOrderHoursPeriod: boolean

    /**
     * When creating a casting with events, the price has to be known.
     * But since the events have to be immediately scheduled, providing a quotation form is not an option.
     */
    backofficeSetCustomPriceWithoutQuotation: boolean

    /**
     * Used when an employee creates a casting on behalf of a customer.
     * This property is set to `true` when the employee selects a customer from the list of customers it worked for.
     */
    employeeAlreadyWorkedForSelectedCustomer: boolean

    /** In desktop environment (on /suppliers/:id/castings/new), the layout needs the container height */
    desktopContainerHeight: number

    showTooltipCloseButton: boolean

    /** Set if the customer is member of a prescriber (whatever it is for a discount or prescriber_casting_fundings) */
    prescriber?: Pick<PrescriberBase, 'id' | 'name' | 'logo' | 'discount_percentage'>

    /**
     * Informations to prefill the customer informations during his registration if he is coming from a prescriber's or a
     * referrer's invitation email.
     */
    invitation?: Pick<InvitationBase, 'id' | 'first_name' | 'last_name' | 'email'>

    /** Referrer customer when current user create his account through uniq referrer referral link or referrer invitation */
    referrerCustomer?: Pick<CustomerBase, 'name'>

    /** Set if customer has accepted GDPR campaigns before submitting the casting */
    hasAcceptedGdprCampaigns: boolean,

    /** Current market identity (supplier or marketplace) */
    market: WebsiteCastingWidgetShowResponse['market']

    /** Data about the countries, the states per country, etc. */
    countries: CountriesData

    /**
     * Will be completed if backofficeFillServiceDelivery is true.
     * Contains delivery and invoicing address to create both the casting and the service_delivery.
     */
    serviceDelivery: {
      delivery_additional: string
      delivery_city: string
      delivery_civility: 'delivery_mister' | 'delivery_madam'
      delivery_corporate_name: string
      delivery_country: string
      delivery_first_name: string
      delivery_last_name: string
      delivery_state: string
      delivery_street: string
      delivery_zipcode: string
      delivery_address_name: string
      delivery_remember_address: boolean
      billing_same_address: boolean
      billing_additional: string
      billing_city: string
      billing_civility: 'billing_mister' | 'billing_madam'
      billing_corporate_name: string
      billing_country: string
      billing_first_name: string
      billing_last_name: string
      billing_state: string
      billing_street: string
      billing_zipcode: string
    }

    /**
     * The customer can express which employees are allowed to postulate / be assigned by the operator.
     * Set if the customer comes from the employee's directory or if it clicks the 'book again' button of an existing casting.
     */
    requiredEmployees: Pick<EmployeeBase, 'id' | 'name' | 'working_days' | 'multi_opening_hours'>[]

    /** See ̀requiredEmployees` comment. */
    requiredSupplier: Pick<SupplierBase, 'id' | 'name' | 'working_days' | 'multi_opening_hours'>

    /** The currently selected service category (chosen in step 'offered-service'). */
    serviceCategory: Pick<ServiceCategoryBase, 'id' | 'name' | 'parent_category_id' | 'offered_service_ids'>

    /** All services categories, as an array, but users explore them as a tree. */
    serviceCategories: CastingStore['data']['serviceCategory'][]

    /** Filter displaied services based on offered_service.rentable */
    onlyRentable: boolean

    /** The currently selected offeredService, detailled. */
    offeredService: Omit<SuppliersCastingsGetServiceResponse, 'offered_options'> & {
      offered_options: (Pick<OfferedOptionBase, 'id' | 'name' | 'description' | 'logo' | 'value_max' | 'value_min' | 'value_step' | 'requireness_on_casting' | 'marketplace_fixed_price'> & ({
        fixed_price_from: { with_tax: number, without_tax: number }
        option_type: 'given_duration' | 'given_quantity'
        'applyness_first_event_of_offered_service_already_satisfied?': boolean
      } | {
        option_type: 'product_catalogue'
        offered_option_offered_services: {
          id: TypedID<'OfferedOptionOfferedService'>
          description: string
          offered_service: Pick<OfferedServiceBase, 'id' | 'name' | 'description_image' | 'quantity_min' | 'quantity_max' | 'quantity_step'> & { unit_price: { with_tax: number, without_tax: number } }
          required_status: OfferedOptionOfferedServiceRequiredStatus
        }[]
      }))[]
    }

    /** Partial informations about services available at some location. */
    offeredServices: Pick<OfferedServiceBase, 'id' | 'not_visible' | 'service_id' | 'description' | 'name'>[]

    /**
     * Set to true if the customer is searching an OfferedService by using a keyword.
     * The search algorithm looks into the title and the description.
     * Under the hook, it uses LUNR.js for simple full-text search (which is lazy loaded).
     */
    offeredServiceEnableSearch: boolean

    /** Keywords or expressions to search in offeredService's names and descriptions */
    offeredServiceSearchKeywords: string

    /**
     * An URL parameter can be provided as ?casting[offered_service_id]=56.
     * When resolving offeredServices, we automatically set the requested OfferedService if present in server's response.
     */
    offeredServiceRequestedId: TypedID<'OfferedService'>

    /**
     * An URL parameter can be provided as ?casting[service_id]=56.
     * When resolving offeredServices, we filter over items of that service.
     */
    serviceRequestedId: TypedID<'Service'>

    /**
     * An URL parameter can be provided as ?casting[casterory_id]=56.
     * When resolving offeredServices, we filter over items of that category.
     */
    categoryRequestedId: TypedID<'Category'>

    /**
     * An URL parameter can be provided as ?casting[service_category_id]=56.
     * When resolving offeredServices, we filter over items of that service category.
     */
    serviceCategoryRequestedId: TypedID<'ServiceCategory'>

    /** Currently selected options, which applies to all slots (some adds price, other adds duration) */
    selectedOptions: {
      offered_option_id: TypedID<'OfferedOption'>
      selected_value: number
      offered_service_id: TypedID<'OfferedService'>
    }[]

    /** Currently selected location */
    city: {
      id: string
      city: string
      lat: number
      lng: number
      postalCode: string
    }

    /** Currently selected country for worldwide casting */
    country: string

    /** All locations resolved against Google Maps API for a raw query string entered by the user */
    cityResults: {
      data: CastingStore['data']['city'][]
      status: 'loading' | 'no-results' | 'results' | 'error' | 'invalid'
    }

    /** If offeredService can be provided at various places (online, at home...), store the customer's choice. */
    requiredPlace: InterventionPlace

    /** If `requiredPlace` === 'onsite', the customer must choose a serviceDeliveryLocation from the list */
    serviceDeliveryLocation: {
      id?: TypedID<'ServiceDeliveryLocation'>
      name: string
      inline_address: string
      latitude: number
      longitude: number
      working_days: WorkingDay[]
      multi_opening_hours: MultiOpeningHours
      distance?: number
    }

    /** If the offered_service allows automatic planning based on the ical link of a lodging, the user is asked for ebabling. */
    enableLodging: boolean

    /** Asked to the customer in order to provide contextual help for retrieving the ical URL */
    lodgingIcalPlatform: 'airbnb' | 'booking' | 'beds24' | 'lodgify' | 'unknown'

    /**
     * A lodging is a location owned by a customer available to rent on platform such as Airbnb or Booking.com.
     * Those platforms expose an ical link to fetch the bookings of the lodging, allowing automatic scheduling of serices such as cleaning.
     * 
     * If the lodging is null, it means the customer does not want to provide the ical link, so is creating a classic oneshot casting.
     * If the lodging is set with an id, it means the customer is logged in and using an existing one. In that case, only the id is taken, because address is imuable.
     * If the lodging is set with an address, it means a new lodging is being created or the customer is not logged in. Duplicates are detected on submit using the ical url.
    */
    lodging: (Pick<LodgingBase, 'id' | 'name'> | (Pick<LodgingBase, 'name' | 'ical_url' | 'checkin_time' | 'checkout_time'>) & {
      address_attributes: Pick<AddressBase, 'street' | 'city' | 'zipcode' | 'state' | 'country' | 'additional'>
    })

    /** Is the casting oneshot or reccurring? */
    castingType: CastingType

    /** Each choice done in the calculator, which finally results in computing `calculatorResult` (used by the legacy calculator) */
    variableMetier: {
      [calculatorName: string]: {
        fields: { [fieldName: string]: any }
      }
    }

    /** Each choice done in the calculator, which finally results in computing `calculatorResult` (used with the new calculator, the one using duration_calculator_items) */
    selectedDurationCalculatorItems: Pick<SelectedDurationCalculatorItemBase, 'id' | 'duration_calculator_item_id' | 'quantity'>[]

    /** Duration computed by the calculator, which then acts as a minimal slot duration */
    calculatorResult: number

    /**
     * Minimum duration computed by the calculator for the first event.
     * 
     * If the first slot by date must occur multiple times and that `slot.duration` is smaller that `calculatorResultFirstEvent`, then:
     * - if oneshot: the slot duration will simply be adjusted inside `toJson()`.
     * - a new oneshot slot will be added inside `toJson()` and the start_date of the reccurring slot adjusted to skip the first reccurrence.
     */
    calculatorResultFirstEvent: number

    /**
     * complexVariantMonoSlotMultiAllowedPatterns = false
     *   -> The complex mode allows the user to create multiple slots, each one having a single allowed pattern.
     * 
     * complexVariantMonoSlotMultiAllowedPatterns = true
     *   -> It results of the choice of the operator/employee currently creating the casting.
     *   -> It promotes multiple allowed patterns over multiple slots.
     * 
     * complexVariantMonoSlotMultiAllowedPatterns = null
     *   -> This is the default value and is similar to false. The only difference is the progress bar computation when 'complex-variant' step is visible.
     */
    complexVariantMonoSlotMultiAllowedPatterns: boolean

    /** Express durations and timeslots of each delivery. Will result in event generation. */
    slots: (CastingSlot & {
      assignable?: {
        id: TypedID<'Employee' | 'OfferedServiceResource'>
        name: string
      }
    })[]

    /** Quantity is set while buying a product */
    quantity: number

    /** Express the customer wants the event to start in X hours. */
    asapOffer: number

    /** Free form message let by the customer to the supplier */
    message: string

    /** Count the number of participants (more informations about them may be asked during serice delivery) */
    participantsNumber: number

    /** Identity of the customer, may be different of the current user (ex. operator creating a casting for a customer) */
    customer: SuppliersCustomerForCastingProps

    /** Pets at delivery place, taken in account to choose an employee that supports them. */
    pets: UnsupportedPets[]

    /** If true, the customer is asking for urssaf payment, so only suppliers and independant employees that configured the API can be matched */
    urssafPayment: boolean

    /** In case of marketplace's promotional codes, the code can be set at in the casting. */
    promotionalCode: Pick<PromotionalCodeBase, 'id' | 'reduction_type' | 'value' | 'code' | 'max_events_per_service_delivery' | 'vat_included'>

    /**
     * Customer plans are prepaid hours (those usage is reset periodically) at a prefered price.
     * When customerPlan is set, it means a draft subscription should be created for that customer plan.
     **/
    customerPlan: Pick<CustomerPlanBase, 'id' | 'quantity' | 'quantity_frequency' | 'name' | 'description' | 'validity_duration_in_months' | 'upfront_payment'> & {
      offered_service_ids: OfferedServiceBase['id'][]
      price_with_tax_cents: number
      price_without_tax_cents: number
    }

    /**
     * If a pending (unvalidated) customer plan subscription exists, the user can:
     * - continue with this subscription: the first casting to be finalized will validate the subscription.
     * - cancel it: the customer_plan_subscription is removed, affecting other castings.
     * - change the plan: both customerPlanSubscriptionRemovePendingId (removing existing) and customerPlan (creating a new subscription) are set.
     */
    customerPlanSubscriptionRemovePendingId: CustomerPlanSubscriptionBase['id']

    /** When a customer plan subscription is expiring soon, the customer can choose an expiration action (resulting in this property to be fillde). */
    customerPlanSubscriptionExpirationAction: Pick<CustomerPlanSubscriptionBase, 'id' | 'expiration_action'>

    /** Coupons are prepaid hours at a prefered price, that the customer chooses for recurrent castings. */
    coupon: Pick<CouponPackBase, 'id' | 'quantity' | 'name' | 'validity_duration_in_months' | 'partial_payment_percentage'> & {
      price_with_tax_cents: number
      price_without_tax_cents: number
    }

    /**
     * - When the SelectedQuantityDiscount has to be created, the browser sends the offered_quantity_discount_id, so the backend can retrieve the discount paramters (unit_of_work,
     * quantity_commitment, discount_percentage, etc.). The unit_of_work, quantity_commitment, etc. are still filled by the frontend code for convenience, but not submitted.
     * 
     * - Once the SelectedQuantityDiscount exists, offered_quantity_discount_id is null, id is a number and unit_of_work, quantity_commitment, discount_percentage... are immutable.
     **/
    selectedQuantityDiscount: Pick<SelectedQuantityDiscountBase, 'id' | 'unit_of_work' | 'quantity_commitment' |  'discount_percentage' | 'validated_at' | 'expires_at' | 'validity_duration_in_months' | 'renewable_from'> & {
      offered_quantity_discount_id?: OfferedQuantityDiscountBase['id']
    }

    /** Attachments are submitted files attached to the casting (files are uploaded to S3 on select and attached to TemporaryAttachment, then moved on casting's submit) */
    attachments: {
      uuid?: string
      state: 'loading' | 'success' | 'error'
      filename: string
      reason?: string
    }[]

    selectedItemPreferenceIds: TypedID<'ItemPreference'>[]
    selectedTaskItemIds: TypedID<'ItemTask'>[]

    /** Product's combinations have multiple attributes. The customer can filter combinations through picked attribute's values. */
    selectedCombinationAttrs: {
      id?: TypedID<'SelectedCombinationAttr'>
      allowed_offered_service_attr_id: TypedID<'AllowedOfferedServiceAttr'>
      value: string
      _destroy?: boolean
    }[]

    /**
     * If the customer is not yet registred, but comes from a prescriber's invitation email, the invitation token is
     * provided for customer registration and prescriber_casting_funding fetching.
     */
    invitationToken: string

    /**
     * Encrypted referrer id to create a referral between the current customer and the referrer
     */
    referrerCustomerToken: string

    /**
     * CustomerOrigin slug to track where the current customer come from when he creates his account
     */
    customerOriginToken: string

    /**
     * Store the price input by the operator when backofficeSetCustomPriceWithoutQuotation is true (only for casting custom prices).
     * 
     * Used to override offered_service.override_rate_*_cents, which is possible for the operator.
     * Employees may also create castings with quotation, but will use the `data.quotation` instead.
     */
    overrideRatePriceCents: number
    overrideRateTaxCents: number
    
    /**
     * If the casting store is mounted in the nominal casting form (ex. /castings/new), that property builds a new quotation object,
     * used when the employee is creating a casting taken in charge by himself.
     * 
     * Operators generally do not use that property, except when the casting store is mounted in /backoffice/quotations/new.
     * Otherwise, the operator can:
     * - create a casting with events (from planning) using overrideRatePriceCents and overrideRateTaxCents (so not using quotation, because
     *   the customer would not be given the opportinity to sign or reject the quotation before events are scheduled).
     * - answer an existing indirect casting (optionnally created by himself) using /castings/:id/answer endpoint.
     */
    quotation: Pick<QuotationBase, 'price_cents' | 'vat_price_cents' | 'round_on_vat_price' | 'signable' | 'description' | 'use_specific_increases' | 'render_monthly_estimation'> & {
      item_quotations_attributes: (
        Pick<ItemQuotationBase, 'description' | 'kind' | 'price_cents' | 'quantity' | 'tax_rules_group_id' | 'verbose_description'> & {
          id?: ItemQuotationBase['id']
          usage?: ItemQuotationBase['usage']
          _destroy?: boolean
        }
      )[]
      cesu_quotation_attributes: Pick<CesuQuotationBase, 'id' | 'management_fee_with_taxes_cents' | 'raw_employee_hourly_salary_cents' | 'employer_charge_percentage' | 'charge_exemption' | 'estimated_monthly_hours'> & {
        cesu_mileage_reimbursement_attributes: Pick<CesuMileageReimbursementBase, 'id' | 'amount_cents' | 'applyness' | 'show_on_document'> & { _destroy?: boolean } | null
      }
    }

    /** When a supplier is creating a casting, it has the opportunity to prevent the broadcast of it (ex. it pick an employee with quotation on the next step) */
    skipBroadcastOnCreate: boolean

    /** Additional data retriven from the URL, that are never changed inside the casting form and mst be submitted */
    additionalData: unknown

    /**
     * When the availabilities of provided within the casting, the appointment_proposals will be constrainted to
     * the customer's preference and will be immediately submitted.
     * 
     * If `null`, no preference is given and the customer will have to pick a date within appointment_proposals' ranges.
     * If set to empty array, it means the user has to input some ranges (unlike appointment_proposal.suggested_ranges, this field cannot be an empty array).
     * If set to non-empty array, it means the customer is availalbe at some time ranges.
     */
    appointmentRequiredRanges: CastingBase['appointment_required_ranges']

    /**
     * When offeredService.enable_groups, the customer choose a groupSessionSchedule.
     * For oneshot casting, it is similar to pick a GroupSession (because oneshot GroupSessionSchedule have a single GroupSession).
     * For recurring casting, it means that GroupSessionSchedule.group_sessions occurring from slots[0].start_date and slots[0].end_date are targetted.
     */
    groupSessionSchedule: SupplierCastingsGetGroupSessionsAtDay['group_sessions'][0]['group_session_schedule']

    /**
     * When the casting is used with some automation or specialized usage, then the UI can hide steps
     * being fully controlled by the parent component.
     */
    focusedInputBlacklist: CastingStore['data']['focusedInput'][]

    errors: {
      errors?: { [key: string]: string[] }
      full_messages?: string[]
    }
  }

  private defaults: Partial<CastingStore['data']> = {
    offeredServices: [],
    requiredEmployees: [],
    slots: [],
    selectedOptions: [],
    selectedDurationCalculatorItems: [],
    attachments: [],
    selectedItemPreferenceIds: [],
    selectedTaskItemIds: [],
    selectedCombinationAttrs: [],
    participantsNumber: 0,
    complexVariantMonoSlotMultiAllowedPatterns: null
  }

  private resetPatterns: { [key in keyof CastingStore['data']]?: (keyof CastingStore['data'])[] } = {
    market: ['serviceCategories', 'offeredService', 'offeredServices', 'countries'],
    backofficePreselectedEmployee: ['city'],
    city: ['serviceCategory', 'offeredServices'],
    country: ['cityResults'],
    serviceCategory: ['offeredService'],
    offeredService: [
      'enableLodging',
      'requiredPlace',
      'serviceDeliveryLocation',
      'castingType',
      'variableMetier',
      'selectedDurationCalculatorItems',
      'calculatorResult',
      'calculatorResultFirstEvent',
      'asapOffer',
      'quantity',
      'attachments',
      'selectedItemPreferenceIds',
      'participantsNumber',
      'selectedCombinationAttrs',
      'quotation',
      'selectedTaskItemIds',
      'customerPlan',
      'selectedQuantityDiscount',
      'customerPlanSubscriptionExpirationAction',
      'promotionalCode'
    ],
    castingType: ['slots', 'complexVariantMonoSlotMultiAllowedPatterns'],
    enableLodging: ['lodging'],
    variableMetier: ['slots'],
    selectedDurationCalculatorItems: ['slots'],
    selectedQuantityDiscount: ['promotionalCode'],
    complexVariantMonoSlotMultiAllowedPatterns: ['slots'],
    slots: ['overrideRatePriceCents', 'overrideRateTaxCents', 'appointmentRequiredRanges'],
    customer: ['employeeAlreadyWorkedForSelectedCustomer'],
    requiredPlace: ['serviceDelivery', 'groupSessionSchedule'],
    serviceDeliveryLocation: ['groupSessionSchedule']
  }

  /**
   * Computed properties return the same cached value for the same arguments.
   * If not available in the cache, the value is asynchronously computed.
   * The variable on which the computation depends are passed as argument.
   * Invariants must be omitted to prevent useless computation.
   */
  asyncComputedProperties = {
    /**
     * Prices are computed on the server side because specific_prices, skilled suppliers, and combinations
     * makes them too complex to computed in the frontend. The computation is debounce for 2 seconds.
     * 
     * To be used when the price depends on the number and duration of events.
     */
    pricedEvents: new AsyncComputedProperty(
      ([displayPriceWithTax]: [
        boolean, // displayPriceWithTax: given as precomputed input to prevent a recomputation of the price when the customer changes in most cases
        StoreProps['data']['city'],
        StoreProps['data']['offeredService'],
        StoreProps['data']['castingType'],
        StoreProps['data']['serviceDeliveryLocation'],
        StoreProps['data']['slots'],
        StoreProps['data']['selectedCombinationAttrs'],
        StoreProps['data']['selectedOptions'],
        StoreProps['data']['calculatorResultFirstEvent'],
        StoreProps['data']['overrideRatePriceCents'],
        StoreProps['data']['overrideRateTaxCents']
      ]) => websiteCastingWidgetPluginComputeCastingPricesForEvents(
        this.data.market,
        { casting: { ...this.toDraftJson().casting, ignored_price_rules_types: castingStoreGetUnaplicableSpecificPricesForEstimate(this.data) } },
        { sync: window.env === 'test', displayPriceWithTax }
      ),
      () => this.forceRender(),
      2000
    ),

    /**
     * Fallback to asyncComputedProperties.pricedEvents, when the price does not depend on the number and duration of events.
     * Currently, this method is used when rentable_unit_of_work is month.
     */
    totalPrice: new AsyncComputedProperty(
      ([displayPriceWithTax]: [
        boolean, // displayPriceWithTax: given as precomputed input to prevent a recomputation of the price when the customer changes in most cases
        StoreProps['data']['city'],
        StoreProps['data']['offeredService'],
        StoreProps['data']['castingType'],
        StoreProps['data']['serviceDeliveryLocation'],
        StoreProps['data']['slots'],
        StoreProps['data']['selectedCombinationAttrs'],
        StoreProps['data']['selectedOptions'],
        StoreProps['data']['calculatorResultFirstEvent'],
        StoreProps['data']['overrideRatePriceCents'],
        StoreProps['data']['overrideRateTaxCents']
      ]) => websiteCastingWidgetPluginComputeCastingTotalPrice(
        this.data.market,
        { casting: { ...this.toDraftJson().casting } },
        { sync: window.env === 'test', displayPriceWithTax }
      ),
      () => this.forceRender(),
      2000
    ),

    /**
     * As soon as the offeredService and the frequency are known, we can fetch availabilities from the server.
     * Under the same array are grouped avaiabilities of a single assignable (Employee or OfferedServiceResource).
     */
    realTimeAvailabilities: new AsyncComputedProperty(
      async (args: [ // eslint-disable-line @typescript-eslint/no-unused-vars
        StoreProps['data']['city'],
        StoreProps['data']['offeredService'],
        StoreProps['data']['castingType'],
        StoreProps['data']['slots'][0]['weeks_interval'],
        StoreProps['data']['requiredPlace'],
        StoreProps['data']['serviceDeliveryLocation']['id'],
        StoreProps['data']['enableLodging'],
        StoreProps['data']['requiredEmployees']
      ]) => {
        if (!this.isRealTime()) return Promise.resolve()
        return websiteCastingWidgetPluginRealtimeAvailabilities(this.data.market, this.toDraftJson(), { sync: window.env === 'test' })
      },
      () => this.forceRender()
    ),

    /**
     * Allows filtering offeredServices with a fulltext search in name and content.
     * It is async because of lazy-loading. In addition, AsyncComputedProperty use a cache,
     * which is useful for CPU-intensive tasks such as building a fulltext index.
     */
    offeredServicesFullTextIndex: new AsyncComputedProperty(
      async ([offeredServices, serviceCategories]: [StoreProps['data']['offeredServices'], StoreProps['data']['serviceCategories']]) => {
        // we use only a small subset of lunr full-text index => we may replace lurn with simpler tokenizer + stemmer + search function
        const { default: lunr } = await import('lunr')

        return lunr(function () {
          this.field('name', { boost: 5 })
          this.field('description')
          this.field('categoryPath')

          for (const os of offeredServices) {
            const serviceCategoriesPath = [serviceCategories.find(sc => sc.offered_service_ids.includes(os.id))]
            while (serviceCategoriesPath[0]) serviceCategoriesPath.unshift(serviceCategories.find(sc => sc.id === serviceCategoriesPath[0].parent_category_id))
            serviceCategoriesPath.shift()

            this.add({ ...os, categoryPath: serviceCategoriesPath.map(_ => _.name).join(' > ') })
          }
        })
      },
      () => this.forceRender()
    ),

    /**
     * When `backofficeSelectAssignableForSlots` is true, an employee/resource can be assigned.
     * The form is submittable only if the assignable is available.
     * Computing availability is done asynchronously using an XHR request.
     * Any change to a slot must trigger a new computation, like adding an end_date later in the process.
     */
    isAssignableAvailableForSlot: new AsyncComputedProperty(
      ([slot, offeredService]: [StoreProps['data']['slots'][0], StoreProps['data']['offeredService']]) => {
        if (!slot.assignable || !slot.allowed_patterns.length) return null
        const endpoint = offeredService.offered_service_type === 'offered_service' ? employeeIsAvailable : offeredServiceResourceIsAvailable
        return endpoint(slot.assignable.id, this.buildAvailableBodyForSlot(slot))
      },
      () => this.forceRender()
    ),

    icalValidationError: new AsyncComputedProperty(
      async ([icalUrl]: [LodgingBase['ical_url']]) => {
        if (icalUrl) return (await websiteCastingWidgetPluginLodgingValidateIcalUrl(this.data.market, icalUrl)).lodging_validation_error
        return null
      },
      () => this.forceRender(),
      window.env === 'test' ? 0 : 2000
    ),

    /**
     * Retrieve available group session dates for a given offered service (fast, for day picker).
     * Returns dates from now to 3 months ahead.
     */
    groupSessionDates: new AsyncComputedProperty(
      async ([castingType, market, offeredService, requiredPlace, serviceDeliveryLocation]: [
        StoreProps['data']['castingType'],
        StoreProps['data']['market'],
        StoreProps['data']['offeredService'],
        StoreProps['data']['requiredPlace'],
        StoreProps['data']['serviceDeliveryLocation']
      ]) => {
        if (!offeredService || !requiredPlace) return null

        const minDate = castingStoreGetMinStartDate(this.data)
        
        return websiteCastingWidgetGetGroupSessionDates(market, {
          casting_type: castingType,
          offered_service_id: offeredService.id,
          required_place: requiredPlace,
          service_delivery_location_id: serviceDeliveryLocation?.id
        }).then(dates => dates.filter(date => moment(date).isAfter(minDate)))
      },
      () => this.forceRender(),
      window.env === 'test' ? 0 : 500
    ),

    /**
     * Retrieve group sessions for a specific day (detailed, for session selection).
     */
    groupSessionsAtDay: new AsyncComputedProperty(
      async ([day, castingType, market, offeredService, requiredPlace, serviceDeliveryLocation]: [
        string | null,
        StoreProps['data']['castingType'],
        StoreProps['data']['market'],
        StoreProps['data']['offeredService'],
        StoreProps['data']['requiredPlace'],
        StoreProps['data']['serviceDeliveryLocation']
      ]) => {
        if (!offeredService || !day || !requiredPlace || !castingType) return null
        
        return websiteCastingWidgetGetGroupSessionsAtDay(market, {
          day,
          casting_type: castingType,
          offered_service_id: offeredService.id,
          required_place: requiredPlace,
          service_delivery_location_id: serviceDeliveryLocation?.id
        }).then(_ => _.group_sessions)
      },
      () => this.forceRender(),
      window.env === 'test' ? 0 : 500
    ),

    /**
     * Determines if employee is directly paid for a given customer and offered service.
     */
    isEmployeeDirectlyPaid: new AsyncComputedProperty(
      async ([employeeId, customer, offeredService]: [
        EmployeeBase['id'],
        StoreProps['data']['customer'],
        StoreProps['data']['offeredService']
      ]) => {
        if (!employeeId || !offeredService) return null

        return employeeIsDirectlyPaid(employeeId, offeredService.id, customer?.id)
      },
      () => this.forceRender()
    )
  }

  constructor () {
    // only used for debugging purpose and test automation
    (window as any).castingStore = this
  }

  init (propsData: Pick<StoreProps['data'], 'renderingMode' | 'market' | 'serviceCategories' | 'countries' | 'frontofficeTranslations'>) {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const offeredServiceRequestedId = urlSearchParams.get('casting[offered_service_id]')
    const serviceRequestedId = urlSearchParams.get('casting[service_id]')
    const categoryRequestedId = urlSearchParams.get('casting[category_id]')
    const serviceCategoryRequestedId = urlSearchParams.get('casting[service_category_id]')

    window.i18n = { ...window.i18n, ...propsData.frontofficeTranslations }

    this.data = {
      ...propsData,
      editedCastingId: null,
      focusedInput: null,
      lastFocusedInput: null,
      backofficeSelectCustomer: false,
      backofficeFillServiceDelivery: false,
      backofficeAllowGroupSession: false,
      backofficeSelectAssignableForSlots: window.currentUser?.type === 'Employee' ? null : false,
      backofficeAllowToStartInPast: false,
      backofficeSkipsWaitingOrderHoursPeriod: false,
      backofficeSetCustomPriceWithoutQuotation: false,
      employeeAlreadyWorkedForSelectedCustomer: false,
      desktopContainerHeight: 0,
      showTooltipCloseButton: true,
      serviceCategory: null,
      offeredService: null,
      offeredServices: [],
      offeredServiceEnableSearch: false,
      offeredServiceSearchKeywords: '',
      offeredServiceRequestedId: offeredServiceRequestedId && parseInt(offeredServiceRequestedId, 10) as TypedID<'OfferedService'>,
      serviceRequestedId: serviceRequestedId && parseInt(serviceRequestedId, 10) as TypedID<'Service'>,
      categoryRequestedId: categoryRequestedId && parseInt(categoryRequestedId, 10) as TypedID<'Category'>,
      serviceCategoryRequestedId: serviceCategoryRequestedId && parseInt(serviceCategoryRequestedId, 10) as TypedID<'ServiceCategory'>,
      selectedOptions: [],
      city: null,
      country: propsData.market.country,
      cityResults: null,
      enableLodging: null,
      lodgingIcalPlatform: null,
      lodging: null,
      requiredPlace: null,
      serviceDeliveryLocation: null,
      castingType: null,
      requiredSupplier: null,
      requiredEmployees: [],
      variableMetier: null,
      selectedDurationCalculatorItems: [],
      calculatorResult: null,
      calculatorResultFirstEvent: null,
      complexVariantMonoSlotMultiAllowedPatterns: null,
      slots: [],
      pets: [],
      asapOffer: null,
      message: null,
      customer: null,
      invitationToken: urlSearchParams.get('token'),
      referrerCustomerToken: urlSearchParams.get('referrer_customer'),
      customerOriginToken: urlSearchParams.get('source'),
      serviceDelivery: null,
      promotionalCode: null,
      customerPlan: null,
      customerPlanSubscriptionRemovePendingId: null,
      customerPlanSubscriptionExpirationAction: null,
      coupon: null,
      selectedQuantityDiscount: null,
      quantity: null,
      attachments: [],
      selectedItemPreferenceIds: [],
      selectedTaskItemIds: [],
      participantsNumber: 0,
      urssafPayment: false,
      selectedCombinationAttrs: [],
      additionalData: null,
      hasAcceptedGdprCampaigns: false,
      overrideRatePriceCents: null,
      overrideRateTaxCents: null,
      quotation: null,
      skipBroadcastOnCreate: false,
      appointmentRequiredRanges: null,
      groupSessionSchedule: null,
      focusedInputBlacklist: [],
      errors: null,

      // an operator should never create a casting for buyable products, since product selling process does not support indirect mode.
      onlyRentable: window.currentUser?.type === 'Operator',
    }

    return this.data
  }

  set (body: Partial<CastingStore['data']>, opts: { runCallbacks: boolean, runResets: boolean, force?: boolean } = { runCallbacks: true, runResets: true }) {
    const oldData = this.data
    const changedKeys = Object.keys(body).filter(key => !oldData || !deepEqualLite((body as any)[key], (oldData as any)[key])) as any
    if (!changedKeys.length && !opts.force) return
    if (body.focusedInput) body.lastFocusedInput = body.focusedInput
    this.data = { ...oldData, ...body }

    if (opts.runResets || opts.runCallbacks || oldData) {
      if (opts.runResets) this.resetCascade(changedKeys, Object.keys(body) as any)
      if (opts.runCallbacks) for (const cb of this.changeListeners) cb(this.data, oldData, changedKeys)
    }

    if (window.env === 'test' && this.data.enableLodging && this.data.slots.some(_ => _.allowed_patterns.length)) {
      throw new Error('Early debugging assertion: cannot have lodging enabled and slots with allowed patterns')
    }
  }

  /**
   * Resetting a field 'offeredService' triggers reset of 'castingType', which triggers reset of 'weeksInterval'...
   */
   resetCascade (changedKeys: (keyof CastingStore['data'])[], processedKeys: (keyof CastingStore['data'])[]) {
    // changedKeys is subject to mutations, so .length may change during iteration
    for (let i = 0; i < changedKeys.length; i++) { //NOSONAR
      const changedKey = changedKeys[i]
      if (!(changedKey in this.resetPatterns)) continue

      for (const cascadeResetKey of this.resetPatterns[changedKey]) {
        if (!processedKeys.includes(cascadeResetKey)) {
          (this.data as any)[cascadeResetKey] = (cascadeResetKey in this.defaults) ? this.defaults[cascadeResetKey] : null
          changedKeys.push(cascadeResetKey)
          processedKeys.push(cascadeResetKey)
        }
      }
    }
  }

  private forceRender () {
    this.set({}, { runCallbacks: true, runResets: false, force: true })
  }

  setDesktopContainerHeight () {
    const castingStepMargin = 30
    const headerHeight = (document.getElementsByClassName('castingHeader-container')[0] as HTMLDivElement).offsetHeight
    const containers = document.getElementsByClassName('castingStep-container')
    const totalContainersHeight = Array.prototype.reduce.call(containers, (total, container, index) => {
      if (index + 1 === containers.length) { return total }
      return total + container.offsetHeight + castingStepMargin
    }, 0) as number

    this.set({ desktopContainerHeight: totalContainersHeight + getWindowHeight() - headerHeight - castingStepMargin })
  }

  async loadSerializedCity (serialized: { city: string, zipcode: string, latitude: number | null, longitude: number | null }) {
    let cityResults: Awaited<ReturnType<typeof castingGeodingSendQuery>>

    if (serialized.city && serialized.latitude !== null && serialized.longitude !== null) {
      cityResults = { status: 'results', data: [{ id: serialized.city, city: serialized.city, lat: serialized.latitude, lng: serialized.longitude, postalCode: serialized.zipcode }] }
    } else {
      const cityInput = serialized.zipcode ? serialized.city + ` (${serialized.zipcode})` : serialized.city
      cityResults = await castingGeodingSendQuery(cityInput, this.data.market)
    }

    this.set({ cityResults }, { runCallbacks: true, runResets: false })

    if (!cityResults.data?.length) {
      this.set({ focusedInput: 'city' })
    } else {
      // With cityInput = "Fort-de-France (97200)", results returned by Google Maps is ["Fonds-Saint-Denis (97200)", "Fort-de-France (97200)"].
      // As shown by the previous example, taking cityResults.data[0] is not always the best choice, so we first try an exact match.
      const cityExactMatch = cityResults.data.find(_ => _.city === serialized.city && _.postalCode === serialized.zipcode)
      await this.setCity(cityExactMatch || cityResults.data[0], { runCallbacks: true, runResets: false })
    }
  }

  async setCity (cityObj: CastingStore['data']['city'], opts = { runCallbacks: true, runResets: true }) {
    const {
      invitationToken, requiredSupplier, requiredEmployees, customer, onlyRentable, offeredServiceRequestedId,
      serviceRequestedId, categoryRequestedId, serviceCategoryRequestedId, backofficeFillServiceDelivery,
      backofficeSelectAssignableForSlots, backofficeSetCustomPriceWithoutQuotation, country
    } = this.data

    const { city, postalCode } = cityObj
    this.set({ city: cityObj }, opts)

    const offeredServices: CastingStore['data']['offeredServices'] = await websiteCastingWidgetPluginGetServices(
      this.data.market,
      {
        postaladdress: `${city}${(postalCode) ? (` (${postalCode})`) : ''}`,
        country,
        token: invitationToken,
        only_rentable: onlyRentable,
        no_casting_custom_price: (backofficeFillServiceDelivery || backofficeSelectAssignableForSlots) && !backofficeSetCustomPriceWithoutQuotation && window.currentUser?.type !== 'Employee',
        no_rentable_unit_of_work_casting: backofficeSetCustomPriceWithoutQuotation,
        customer_id: customer?.id,
        required_supplier_id: requiredSupplier?.id || (window.currentUser?.market_type === 'Supplier' ? window.currentUser.market_id : undefined),
        service_id: serviceRequestedId,
        category_id: categoryRequestedId,
        'required_employee_ids[]': requiredEmployees.map(_ => _.id),
        cordovaPackageName: await window.cordova?.getAppVersion.getPackageName(),
        cordovaPackageVersionCode: await window.cordova?.getAppVersion.getVersionCode()
      }
  )

    this.set({ offeredServices }, opts)

    if (offeredServiceRequestedId) {
      const requestedOfferedService = offeredServices.find(_ => _.id === offeredServiceRequestedId)
      await this.setOfferedService(requestedOfferedService as any || null)
    }

    if (serviceCategoryRequestedId) {
      const requestedServiceCategory = this.data.serviceCategories.find(_ => _.id === serviceCategoryRequestedId)
      this.set({ serviceCategory: requestedServiceCategory || null })
    }
  }

  async fetchOfferedService (id: OfferedServiceBase['id']) {
    const offeredService = await websiteCastingWidgetPluginOfferedService(this.data.market, id, { token: this.data.invitationToken, customer_id: this.data.customer?.id })

    if (window.currentUser?.type === 'Operator') {
      // an operator should never create a casting for products, since product selling process does not support indirect mode.
      offeredService.offered_options = offeredService.offered_options.filter(oo => oo.option_type !== 'product_catalogue')
    }

    return offeredService
  }

  async setOfferedService (offeredService: CastingStore['data']['offeredService'], opts = { runCallbacks: true, runResets: true }) {
    if (offeredService && !('frontoffice_translations' in offeredService)) {
      // this service has been lazy loaded and some fields are missing
      offeredService = await this.fetchOfferedService((offeredService as any).id)
    }

    if (!offeredService) return this.set({ offeredService }, opts)

    if (offeredService.enable_groups && window.currentUser?.type && window.currentUser?.type !== 'Customer') {
      if (this.data.backofficeAllowGroupSession && this.data.backofficePreselectedEmployee) {
        return modalOpenAlert(i18nScoped.t('offered_service_not_selectable'), i18nScoped.t('offered_service_group_session_preseleced_employee'))
      } else if (!this.data.backofficeAllowGroupSession) {
        return modalOpenAlert(i18nScoped.t('offered_service_not_selectable'), i18nScoped.t('offered_service_group_session_not_customer'))
      }
    }

    const body: Partial<CastingStore['data']> = { offeredService }
    body.offeredServices = this.data.offeredServices.map(_ => _.id === offeredService.id ? offeredService : _)

    if (offeredService.buyable && !offeredService.rentable) {
      // MONKEY PATCH : buyable, but not rentable products virtually set the 'casting_one_shot' property. This allows the price calculation...
      body.castingType = 'casting_one_shot'
    } else if (offeredService.asap_only) {
      // in asap_only mode, only oneshot casting is allowed.
      body.castingType = 'casting_one_shot'
    } else if (offeredService.casting_one_shot !== offeredService.casting_recurring) {
      body.castingType = offeredService.casting_recurring ? 'casting_recurring' : 'casting_one_shot'
    }

    if (offeredService.require_participants_number) body.participantsNumber = offeredService.participant_min || 0

    body.selectedQuantityDiscount = offeredService.selected_quantity_discount_for_customer ?? null

    this.reevaluateMandatoryOfferedOptions(body, offeredService)
    this.set(body, opts)

    if (offeredService.intervention_places.length === 1) this.setRequiredPlace(offeredService.intervention_places[0])

    if (offeredService.require_selected_quantity_discount && !body.selectedQuantityDiscount && offeredService.active_offered_quantity_discounts.length === 1) {
      this.setOfferedQuantityDiscount(offeredService.active_offered_quantity_discounts[0], opts)
    }
  }

  /** Used when an operator a customer belonging to a marketplace */
  async setBackofficeCustomerAndFetchMarket (customer: CastingStore['data']['customer']) {
    if (customer.marketplace && window.currentUser.market_type === 'Supplier' && !customer.marketplace['supplier_can_create_events_for_its_customers?']) {
      await modalOpenAlert(i18nScoped.t('supplier_cannot_create_events_for_its_customers'), i18nScoped.t('supplier_cannot_create_events_for_its_customers_description', { name: customer.marketplace.name }))
      return false
    }
    
    if (customer.market_type !== this.data.market.market_type || customer.market_id !== this.data.market.id) {
      // the market of the selected customer is not the market of the form => reload context for the form
      const json = await websiteCastingWidgetPluginDataPreview({
        name: 'CastingBackofficeCustomerPickerComponent',
        market_type: customer.market_type,
        market_id: customer.market_id,
        main_color: window.marketColors.clr_1,
        submit_button_color: window.marketColors.clr_1,
        locale: window.locale
      })
          
      this.set({ market: json.market, serviceCategories: json.service_categories, countries: json.countries })
    }

    this.set({ customer })
    if (this.data.offeredService) await this.checkOfferedServiceAdjustmentOnceCustomerIsKnown()

    return true
  }

  /**
   * We resolved the offered_service before the customer is known => some data may be obsolete and be rejected on casting submit.
   * This method process some possible cases for smoother experience.
   **/
  async checkOfferedServiceAdjustmentOnceCustomerIsKnown () {
    // store.customer is now set, allowing to fetch the offered_service with contextual data for the customer
    Object.assign(this.data.offeredService, await this.fetchOfferedService(this.data.offeredService.id))

    if (this.data.offeredService.selected_quantity_discount_for_customer) {
      this.set({ selectedQuantityDiscount: this.data.offeredService.selected_quantity_discount_for_customer })

      // discount loaded: if it is still in draft, redirect the user to the right screen for review
      await modalOpenDecorated(
        i18nScoped.t('selected_quantity_discount_for_customer_found'),
        () => React.createElement('div', { style: { textAlign: 'center', padding: '1em' } }, i18nScoped.t('selected_quantity_discount_for_customer_found_description'))
      )

      const shouldFocusQuantityDiscountStep = !this.data.offeredService.selected_quantity_discount_for_customer.validated_at
        // ...or expires soon
        || moment(this.data.offeredService.selected_quantity_discount_for_customer.renewable_from).isBefore(moment()) && this.data.offeredService.active_offered_quantity_discounts.length > 0

      if (shouldFocusQuantityDiscountStep) this.tryFocus('quantity-discount', { scroll: true })
      throw { errors: {}, full_messages: [] } satisfies StoreProps['data']['errors']
    }
  }
  
  setRequiredPlace (requiredPlace: InterventionPlace) {
    const { offeredService, city } = this.data
    let { serviceDeliveryLocation } = this.data

    if (requiredPlace !== 'on_site') {
      serviceDeliveryLocation = null
    } else if (city && offeredService.service_delivery_locations.length === 1) {
      const sdl = offeredService.service_delivery_locations[0]
      serviceDeliveryLocation = { ...sdl, distance: geocodingGeodesicDistance({ latitude: sdl.latitude, longitude: sdl.longitude }, { latitude: city.lat, longitude: city.lng }, 2) }
    }

    this.set({ requiredPlace, serviceDeliveryLocation })
  }

  setCastingType (castingType: CastingType) {
    if (castingType !== this.data.castingType) {
      this.set({ castingType })
      
      const body: Partial<CastingStore['data']> = {}
      this.reevaluateMandatoryOfferedOptions(body, this.data.offeredService)
      this.set(body)
    }
  }

  /** When OfferedService or CastingType changes, the preselected offeredServices must be reevaluated. */
  private reevaluateMandatoryOfferedOptions (body: Partial<CastingStore['data']>, offeredService: CastingStore['data']['offeredService']) {
    const castingType = body.castingType ?? this.data.castingType

    body.selectedOptions = (this.data.selectedOptions || []).filter(selectedOption => {
      const offeredOption = offeredService.offered_options.find(oo => oo.id === selectedOption.offered_option_id)

      // all options must be valid for this service
      if (!offeredOption) return false

      // an offered_option selected because of requireness for a previous value of `castingType` should be reset
      if (offeredOption.requireness_on_casting !== 'no_required' && !this.isOfferedOptionMandatory(offeredOption, castingType)) return false

      return true
    })

    // some options are selected by default. Some are always required or if required for the first casting (server sets `required_status` depending the current_user)
    for (const offeredOption of offeredService.offered_options) {
      // ignore that offeredOption if it is already selected
      if (body.selectedOptions.find(_ => _.offered_option_id === offeredOption.id)) continue

      // the offered_option could be required (ex. fees, etc.)
      if (offeredOption.option_type !== 'product_catalogue' && this.isOfferedOptionMandatory(offeredOption, castingType)) {
        body.selectedOptions.push({ offered_option_id: offeredOption.id, selected_value: offeredOption.value_min, offered_service_id: null })
      }

      // a product of the catalog could be required
      if (offeredOption.option_type === 'product_catalogue') {
        for (const offeredOptionOfferedService of offeredOption.offered_option_offered_services) {
          if (offeredOptionOfferedService.required_status === 'required') {
            body.selectedOptions.push({
              offered_option_id: offeredOption.id,
              selected_value: offeredOptionOfferedService.offered_service.quantity_min,
              offered_service_id: offeredOptionOfferedService.offered_service.id
            })
          }
        }
      }
    }
  }

  setGroupSession (session: SupplierCastingsGetGroupSessionsAtDay['group_sessions'][0]) {
    const { castingType } = this.data

    if (castingType === 'casting_recurring' && session.group_session_schedule.frequency !== 'weekly') {
      throw new Error("session.group_session_schedule is expected to be weekly (slots only handle weeks_interval)")
    }

    this.setSlots([{
      start_date: moment(session.start_date).format('YYYY-MM-DD'),
      end_date: castingType === 'casting_one_shot' ? null : moment(session.group_session_schedule.end_date).subtract(1, 'day').format('YYYY-MM-DD'),
      duration: moment(session.end_date).diff(moment(session.start_date), 'seconds'),
      weeks_interval: castingType === 'casting_one_shot' ? null : session.group_session_schedule.interval,
      allowed_patterns: [{
        day_id: moment(session.start_date).day(),
        from_hour: moment(session.start_date).format('HH:mm'),
        until_hour: moment(session.end_date).format('HH:mm'),
        additional_days: null as number
      }]
    }])

    this.set({ groupSessionSchedule: session.group_session_schedule })
  }

  setPromotionalCode (promotionalCode: CastingStore['data']['promotionalCode']) {
    this.set({ promotionalCode, selectedQuantityDiscount: null })
  }

  setCoupon (coupon: CastingStore['data']['coupon']) {
    this.set({ coupon, selectedQuantityDiscount: null })
  }

  setOfferedQuantityDiscount (offeredQuantityDiscount: CastingStore['data']['offeredService']['active_offered_quantity_discounts'][0], opts = { runCallbacks: true, runResets: true }) {
    if (!offeredQuantityDiscount) return this.set({ selectedQuantityDiscount: null }, opts)

    this.set({
      selectedQuantityDiscount: {
        id: null,
        offered_quantity_discount_id: offeredQuantityDiscount.id,
        discount_percentage: offeredQuantityDiscount.discount_percentage,
        quantity_commitment: offeredQuantityDiscount.quantity_commitment,
        unit_of_work: offeredQuantityDiscount.unit_of_work,
        validity_duration_in_months: offeredQuantityDiscount.validity_duration_in_months,
        validated_at: null,
        expires_at: null,
        renewable_from: null
      }
    }, opts)
  }

  setSelectedCombinationAttrs (selectedCombinationAttrs: CastingStore['data']['selectedCombinationAttrs']) {
    this.set({ selectedCombinationAttrs })

    // when selectedCombinationAttrs change, there is a risk the currently selected service_delivery_location becomes invalid
    if (this.data.serviceDeliveryLocation && !this.getServiceDeliveryLocations().some(sdl => sdl.id === this.data.serviceDeliveryLocation.id)) this.set({ serviceDeliveryLocation: null })
  }

  setSlots (slots: CastingStore['data']['slots']) {
    const { backofficeSelectAssignableForSlots, backofficePreselectedEmployee, offeredService } = this.data

    if (backofficeSelectAssignableForSlots && backofficePreselectedEmployee && offeredService.offered_service_type === 'offered_service') {
      const assignable = { id: backofficePreselectedEmployee.id, name: backofficePreselectedEmployee.name }
      slots = slots.map(slot => slot.assignable ? slot : { ...slot, assignable })
    }

    this.set({ slots })
  }

  initSlotWithDuration (duration: number, startDatetime?: moment.Moment) {
    this.setSlots([castingStoreBuildSlotWithDuration(this.data, duration, startDatetime)])
  }

  isOfferedOptionMandatory (offeredOption: CastingStore['data']['offeredService']['offered_options'][0], castingType = this.data.castingType) {
    return castingStoreIsOfferedOptionMandatory(offeredOption, castingType)
  }

  isOfferedOptionVisible (offeredOption: CastingStore['data']['offeredService']['offered_options'][0]) {
    return castingStoreIsOfferedOptionVisible(this.data, offeredOption)
  }

  setLodgingCheckinTime (time: string) {
    const lodging = this.data.lodging
    if (('id' in lodging)) throw new Error('Lodging must have a checkout_time')
    const newCheckoutTime = lodging.checkout_time && parseTime(time) > parseTime(lodging.checkout_time) ? lodging.checkout_time : null
    this.set({ lodging: { ...lodging, checkin_time: time, checkout_time: newCheckoutTime } })
  }

  setLodgingCheckoutTime (time: string) {
    const lodging = this.data.lodging
    if (('id' in lodging)) throw new Error('Lodging must have a checkout_time')
    const newCheckinTime = lodging.checkin_time && parseTime(time) < parseTime(lodging.checkin_time) ? lodging.checkin_time : null
    this.set({ lodging: { ...lodging, checkout_time: time, checkin_time: newCheckinTime } })
  }
  
  setError (err: Error | CastingStore['data']['errors'] | { error: string }) {
    if ('error' in err) this.set({ errors: { full_messages: [err.error] } })
    else if ('errors' in err || 'full_messages' in err) this.set({ errors: err })
    else this.set({ errors: i18nScoped.t('unknown_error') })
    if (err instanceof Error) throw err
  }

  previousFocus () {
    if (!this.data.focusedInput && this.data.lastFocusedInput) {
      this.tryFocus(this.data.lastFocusedInput)
      this.set({ lastFocusedInput: null })
      return true
    }

    const focusedInputWas = this.data.focusedInput
    let previousFocus = this.getPreviousActivableFocus(this.data.focusedInput)

    if (previousFocus === 'end-of-step-1' || previousFocus === 'end-of-step-2') {
      previousFocus = this.getPreviousActivableFocus(previousFocus)
    }

    this.set({ focusedInput: previousFocus })
    if (!previousFocus) this.set({ lastFocusedInput: null })
    return !!focusedInputWas
  }

  nextFocus ({ from = this.data.focusedInput, closeOnMobile = false } = {}) {
    const { renderingMode } = this.data
    if (renderingMode === 'mobile' && closeOnMobile) {
      this.set({ focusedInput: null })
    } else if (from) {
      let focusedInput = this.getNextActivableFocus(from)
      if (focusedInput === 'end-of-step-1' || focusedInput === 'end-of-step-2') focusedInput = null
      this.set({ focusedInput })
    }
  }

  tryFocus (step: CastingStore['data']['focusedInput'], { toggle = false, scroll = false }: { toggle?: boolean, scroll?: boolean } = {}) {
    this.set({ focusedInput: this.canFocus(step) && (!toggle || this.data.focusedInput !== step) ? step : null })
    if (scroll) this.scrollToLegacyStep?.(castingStoreGetLegacyStepOfFocusedInput(this.data, step))
  }

  canFocus (step: CastingStore['data']['focusedInput']): boolean {
    return castingStoreCanFocus(this.data, step)
  }

  /** Overridden by the container */
  scrollToLegacyStep: (legacyStep: 1 | 2 | 3) => void = null

  getMultiOpeningHours ({ areAllowedPatternFrozen = false } = {}) {
    return castingStoreGetMultiOpeningHours(this.data, { areAllowedPatternFrozen })
  }

  /** Returns the minimum duration volume (comparable to slots[].duration, could be > to offeredService.max_slot_duration_per_employee) */
  getMinDuration () {
    return castingStoreGetMinDuration(this.data)
  }

  /** Returns the maximum duration volume (comparable to slots[].duration, could be > to offeredService.max_slot_duration_per_employee) */
  getMaxDuration () {
    return castingStoreGetMaxDuration(this.data)
  }

  /** Returns the max possible value for `allowedPattern.until_hour - allowedPattern.from_hour`, considering too long durations will be splited in multiple assignments */
  getDurationForAllowedPattern () {
    return castingStoreGetDurationForAllowedPattern(this.data)
  }

  formatSelectedOption (so: ReturnType<CastingStore['getSelectedOptionJoined']>[0], withName = false) {
    return castingStoreFormatSelectedOption(this.data, so, withName)
  }

  getMinStartDate () {
    return castingStoreGetMinStartDate(this.data)
  }

  getMinRecurrenceEndDate () {
    return castingStoreGetMinRecurrenceEndDate(this.data)
  }

  getMaxRecurrenceEndDate () {
    return castingStoreGetMaxRecurrenceEndDate(this.data)
  }

  /**
   * Check if a day could be a valid start date by checking:
   * - if the realtime planning allows this date, and ;
   * - if the earlier allowed pattern (if any) is after waiting period, and ;
   * - if the multi opening hour range is large enough for the slot duration, and ;
   * - if the latest possible start date is after waiting period.
   */
  isStartDayDisabled (
    date: Date,
    multiOpeningHours: UnserializedMultiOpeningHours & { reduced: true, midnightSafe: true },
    opts: { duration?: number, allowedPatterns?: CastingSlot['allowed_patterns'], tracingContainer?: StartDayDisabledTracing[] } = {}
  ) {
    return castingStoreIsStartDayDisabled(this.data, this, date, multiOpeningHours, opts)
  }

  getFirstEnabledDateFrom (startingFromDate: Date, isDisabled: (date: Date) => boolean) {
    return castingStoreGetFirstEnabledDateFrom(startingFromDate, isDisabled)
  }

  isRealTime () {
    return castingStoreIsRealTime(this.data)
  }

  isReadyForSubmitPlugin () {
    return castingStoreIsReadyForSubmitPlugin(this.data, this)
  }

  /** Returns true if the offeredService is complex for current castingType */
  isComplex () {
    return castingStoreIsComplex(this.data)
  }

  /** allowing any time means that the customer is available 24h/7d (TODO: should follow offered_services moh) */
  isAllowingAnyTime () {
    return castingStoreIsAllowingAnyTime(this.data)
  }

  /** allowing any time means you are available 24h/7d */
  toggleAllowAnyTime (withStartDate?: string) {
    const slots = this.data.slots
    
    if (castingStoreIsAllowingAnyTime(this.data)) {
      this.setSlots([{ ...slots[0], allowed_patterns: [] }])
      return false
    } else {
      const allowed_patterns = ([0, 1, 2, 3, 4, 5, 6] as const).map(dayId => ({ day_id: dayId, from_hour: '00:00', until_hour: '24:00', additional_days: null as number }))
      this.setSlots([{ ...slots[0], start_date: withStartDate || slots[0].start_date, allowed_patterns }])
      return true
    }
  }

  /** Returns SelectedOption LEFT JOIN OfferedOption LEFT JOIN OfferedOptionOfferedService */
  getSelectedOptionJoined () {
    return castingStoreGetSelectedOptionJoined(this.data)
  }

  /**
   * In case of prescribers for example, we have to set an end_date for the recurrence,
   * so total event's duration stay lower than allowed duration in the prescriber's plan.
   */
  simulateOccurrencesUpToMaxAllowedDuration (allowedHours: number, overrides: { end_date?: string } = {}) {
    return castingStoreSimulateOccurrencesUpToMaxAllowedDuration(this.data, allowedHours, overrides)
  }

  getCustomerBoughtCouponsPackInsights () {
    return castingStoreGetCustomerBoughtCouponsPackInsights(this.data)
  }

  /**
   * Server side validations are responsible to align end_dates of prescriber_casting_fundings
   * which overlaps by period, with the same offered_services and ref.
   * 
   * In the eventuallity this is not the case, the casting always takes the minimum end_date.
   */
  getPrescriberPrescriberCastingFundingEndDate () {
    return castingStoreGetPrescriberPrescriberCastingFundingEndDate(this.data)
  }

  getPrescriberRemainingFundedHours () {
    return castingStoreGetPrescriberRemainingFundedHours(this.data)
  }

  getAllowedAttributeJustAfterOfferedService () {
    return castingStoreGetAllowedAttributeJustAfterOfferedService(this.data)
  }

  getAllowedAttributesOfStep2 () {
    return castingStoreGetAllowedAttributesOfStep2(this.data)
  }

  getServiceDeliveryLocations () {
    return castingStoreGetServiceDeliveryLocations(this.data)
  }

  getCombinationsMatchingSelectedAttrs (ignoredAllowedAttrIds: TypedID<'AllowedOfferedServiceAttr'>[]) {
    return castingStoreGetCombinationsMatchingSelectedAttrs(this.data, ignoredAllowedAttrIds)
  }

  getTabsForOfferedServiceDescription () {
    return castingStoreGetTabsForOfferedServiceDescription(this.data)
  }

  hasError (fieldName: string) {
    return castingStoreHasError(this.data, fieldName)
  }

  getStepTitle (step: CastingStore['data']['focusedInput']): string {
    return castingStoreGetStepTitle(this.data, step)
  }

  getProgressForStep (step: CastingStore['data']['focusedInput']): number {
    return castingStoreGetProgressForStep(this.data, this, step)
  }

  getSummaryForStep (step: CastingStore['data']['focusedInput']): string {
    return castingStoreGetSummaryForStep(this.data, this, step)
  }

  getFocusedInputInLegacyStep (step: 1 | 2 | 3) {
    return castingStoreGetFocusedInputInLegacyStep(this.data, step)
  }

  /** Returns true if the casting step is fully completed. */
  validatesLegacyCastingStep (step: 1 | 2) {
    return castingStoreValidatesLegacyCastingStep(this.data, this, step)
  }

  /** Rentable prices are too complex to be computed on the front-end: compute price matric asynchronously in backend. */
  getPricedEvents (lazy = false) {
    return castingStoreGetPricedEvents(this.data, this, lazy)
  }

  getRealTimeAvailabilities () {
    return castingStoreGetRealTimeAvailabilities(this.data, this)
  }

  /**
   * Returns true if datetime is included in an availability and if the incomming part of the availability
   * is equal of greater to `minDurationInSeconds`.
   */
  hasRealTimeAvailabilityAtTime (datetime: moment.Moment | Date, minDurationInSeconds: number) {
    return castingStoreHasRealTimeAvailabilityAtTime(this.data, this, datetime, minDurationInSeconds)
  }

  /**
   * Returns a body that could be submitted to /employees/:id/available_at.
   * It is used by operator, when able to select any assignable from their codebase.
   * For other cases (ex. realtime for customers), `hasRealTimeAvailabilityAtTime` should be prefered (more efficient, assignable-agnostic).
   */
  buildAvailableBodyForSlot (slot: StoreProps['data']['slots'][0]) {
    return castingStoreBuildAvailableBodyForSlot(this.data, slot)
  }

  /** Returns true if the operator is currently editing an existing casting. */
  isEditingCasting () {
    return castingStoreIsEditingCasting(this.data)
  }

  /** Serialize casting a a payload that can be sent to /casting/new */
  toJson () {
    return castingStoreToJson(this.data)
  }

  /**
   * Same as toJson, but suppose the slots are not yet ready to be submitted to the server (and need some patches).
   * Used for example to compute a price estimation and update it while the customer edits the casting.
   */
  toDraftJson () {
    return castingStoreToDraftJson(this.data)
  }

  private getPreviousActivableFocus (currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
    return castingStoreGetPreviousActivableFocus(this.data, currentFocus)
  }

  private getNextActivableFocus (currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
    return castingStoreGetNextActivableFocus(this.data, currentFocus)
  }

  /**
   * Get available group session dates for the current offered service.
   * @returns AsyncComputedProperty result containing available dates (fast, for day picker)
   */
  getGroupSessionDates () {
    return this.asyncComputedProperties.groupSessionDates.readOrAsyncCompute([
      this.data.castingType,
      this.data.market,
      this.data.offeredService,
      this.data.requiredPlace,
      this.data.serviceDeliveryLocation
    ])
  }

  /**
   * Get group sessions for a specific day.
   * @param day ISO date string (YYYY-MM-DD)
   * @returns AsyncComputedProperty result containing group sessions for the day
   */
  getGroupSessionsAtDay (day: string) {
    return this.asyncComputedProperties.groupSessionsAtDay.readOrAsyncCompute([
      day,
      this.data.castingType,
      this.data.market,
      this.data.offeredService,
      this.data.requiredPlace,
      this.data.serviceDeliveryLocation
    ])
  }
}

type CastingStoreBuildSlotWithDurationData = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreBuildSlotWithDuration ({ offeredService }: CastingStoreBuildSlotWithDurationData, duration: number, startDatetime?: moment.Moment): CastingSlot {
  const slotDuration = offeredService.no_start_time_nor_duration_asked_to_customer && offeredService.rentable_unit_of_work !== 'event' ? null : duration

  return {
    start_date: startDatetime?.format('YYYY-MM-DD'),
    end_date: null,
    duration: slotDuration,
    weeks_interval: null,
    allowed_patterns: startDatetime && slotDuration ? [{ day_id: startDatetime.day(), from_hour: startDatetime.format('HH:mm'), until_hour: startDatetime.clone().add(slotDuration, 'seconds').format('HH:mm'), additional_days: null }] : []
  }
}

export function castingStoreIsOfferedOptionMandatory (offeredOption: CastingStore['data']['offeredService']['offered_options'][0], castingType: CastingStore['data']['castingType']) {
  // if the option only applies once per offered_service and was already planned, ignore it.
  if (offeredOption.option_type !== 'product_catalogue' && offeredOption['applyness_first_event_of_offered_service_already_satisfied?']) return false

  return offeredOption.requireness_on_casting === 'required' ||
    (castingType === 'casting_one_shot' && offeredOption.requireness_on_casting === 'required_oneshot') ||
    (castingType === 'casting_recurring' && offeredOption.requireness_on_casting === 'required_recurring')
}

type CastingStoreIsOfferedOptionVisibleData = Pick<CastingStore['data'], 'castingType'>
export function castingStoreIsOfferedOptionVisible (data: CastingStoreIsOfferedOptionVisibleData, offeredOption: CastingStore['data']['offeredService']['offered_options'][0]) {
  // if the option only applies once per offered_service and was already planned, ignore it.
  if (offeredOption.option_type !== 'product_catalogue' && offeredOption['applyness_first_event_of_offered_service_already_satisfied?']) return false

  // an option required (always or under some circonstance) should be ignored if not mandatory in the current context.
  return offeredOption.requireness_on_casting === 'no_required' || castingStoreIsOfferedOptionMandatory(offeredOption, data.castingType)
}

type CastingStoreAvailableCustomerPlanSubscriptionsData = Pick<CastingStore['data'], 'customer' | 'offeredService'>
export function castingStoreAvailableCustomerPlanSubscriptions ({ customer, offeredService }: CastingStoreAvailableCustomerPlanSubscriptionsData) {
  return customer?.customer_plan_subscriptions?.filter(cps => cps.offered_services.some(os => os.id === offeredService?.id)) || []
}

type CastingStoreGetExpiringCustomerPlanSubscriptionData = Pick<CastingStore['data'], 'customer' | 'offeredService' | 'customerPlanSubscriptionRemovePendingId'>
export function castingStoreGetExpiringCustomerPlanSubscription (data: CastingStoreGetExpiringCustomerPlanSubscriptionData) {
  const availableCustomerPlanSubscriptions = castingStoreAvailableCustomerPlanSubscriptions(data).filter(_ => _.id != data.customerPlanSubscriptionRemovePendingId)

  // the customer UI displays the draft subscription, so expiring subscription is not displayed
  if (!availableCustomerPlanSubscriptions.some(_ => _.validated_at)) return { expiringSubscription: null, delayInDays: null }
  if (availableCustomerPlanSubscriptions.length === 0) return { expiringSubscription: null, delayInDays: null }

  const furthestSubscription = availableCustomerPlanSubscriptions
    .reduce((latest, current) => moment(current.expires_at).isAfter(moment(latest.expires_at)) ? current : latest)

  const delayInDays = Math.ceil(moment(furthestSubscription.expires_at).diff(moment(), 'days', true))
  if (delayInDays < 0 || delayInDays > 14) return { expiringSubscription: null, delayInDays }

  return { expiringSubscription: furthestSubscription, delayInDays }
}

type CastingStoreCanFocusData = Pick<CastingStore['data'], 'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'backofficeSetCustomPriceWithoutQuotation' | 'enableLodging' | 'lodging' | 'coupon' | 'promotionalCode' | 'requiredPlace' | 'serviceDeliveryLocation' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'customerPlan'>
export function castingStoreCanFocus (data: CastingStoreCanFocusData, step: CastingStore['data']['focusedInput']): boolean {
  const {
    editedCastingId, renderingMode, backofficeSelectCustomer, backofficeFillServiceDelivery, backofficeSelectAssignableForSlots, employeeAlreadyWorkedForSelectedCustomer,
    city, offeredService: os, castingType, slots, customer, backofficeSetCustomPriceWithoutQuotation, enableLodging, lodging, coupon, promotionalCode, requiredPlace,
    serviceDeliveryLocation, groupSessionSchedule, focusedInputBlacklist, customerPlan, offeredService
  } = data

  if (focusedInputBlacklist.includes(step)) return false

  const castingTypeSetOrIgnored = !!castingType || !castingStoreCanRenderCastingTypeInput(data)

  switch (step) {
    case 'end-of-step-1':
    case 'end-of-step-2':
      return renderingMode !== 'widget' // break the focusNext() chain on end of step reanched if steps are revelant
    case 'backoffice-customer': return backofficeSelectCustomer
    case 'backoffice-service-delivery':
      if (!customer?.addresses || !slots.length) return false
      if (backofficeFillServiceDelivery) return true
      if (renderingMode === 'widget' || editedCastingId) return false
      if (os.casting_custom_price || slots[0].duration === null) return false
      return (window.currentUser?.type === 'Operator' && window.currentUser.market_type === 'Supplier') || (window.currentUser?.type === 'Employee' && employeeAlreadyWorkedForSelectedCustomer && customer['has_any_valid_payment_mode?'])
    case 'employee-quotation': return window.currentUser?.type === 'Employee' && os?.casting_custom_price && !os.enable_employee_of_customer && backofficeSelectAssignableForSlots && employeeAlreadyWorkedForSelectedCustomer
    case 'city': return !backofficeSelectCustomer || !!customer
    case 'offered-service': return !!city
    case 'enable-lodging': return os?.rentable && os.enable_lodging_ical_link && !backofficeSelectAssignableForSlots && window.currentUser?.type !== 'Employee' 
    case 'lodging': return city && enableLodging
    case 'lodging-ical': return enableLodging && lodging && !('id' in lodging)
    case 'lodging-check-in-out': return enableLodging && lodging && 'checkin_time' in lodging
    case 'required-place': return os && (os.intervention_places.length > 1 || os.intervention_places[0] === 'on_site')
    case 'quantity': return os?.buyable
    case 'group-session': return os?.rentable && os.enable_groups && !!castingType && !!requiredPlace && (requiredPlace !== 'on_site' || !!serviceDeliveryLocation)
    case 'complex-variant': return castingStoreIsComplex(data) && ['Operator', 'Employee'].includes(window.currentUser?.type) && !backofficeSelectAssignableForSlots
    case 'start-date': return castingTypeSetOrIgnored && os?.rentable && !os.enable_groups && (castingType === 'casting_recurring' || !castingStoreIsComplex(data)) && (!os.enable_lodging_ical_link || enableLodging !== null)
    case 'end-date': return os?.rentable && (backofficeSelectAssignableForSlots || os.end_date_recurrence || os.enable_groups) && slots.length > 0 && slots[0].start_date && castingType === 'casting_recurring'
    case 'duration': {
      if (!os?.rentable || !castingType || os.enable_groups) return false

      if (os.enable_duration_calculator) {
        return os.duration_calculator_items.length > 0
      } else {
        if (!os.param_metier || !os.service.metier) return false
        const metierKey = Object.keys(os.param_metier)[0]
        return !!os.service.metier[metierKey] && !!os.param_metier[metierKey]
      }
    }
    case 'complex': return os?.rentable && castingStoreIsComplex(data)
    case 'frequency': return os?.rentable && castingType === 'casting_recurring' && !os.enable_groups && !castingStoreIsComplex(data)
    case 'options': return castingTypeSetOrIgnored && os?.rentable && os.offered_options.filter(oo => castingStoreIsOfferedOptionVisible(data, oo)).length > 0
    case 'customer-plan':
      return os?.['duration_funding_compatible?'] &&
        os?.customer_plans.length > 0 &&
        !os.prescriber_casting_fundings_for_customer &&
        !os.selected_quantity_discount_for_customer
    case 'coupon':
      return os?.['duration_funding_compatible?'] &&
        os.coupons_packs.length > 0 &&
        !os.prescriber_casting_fundings_for_customer &&
        !os.selected_quantity_discount_for_customer
    case 'quantity-discount': {
      if (!os?.rentable || !os.active_offered_quantity_discounts.length) return false

      // quantity discount cannot be applyed if the casting already befenit from another kind of discount (existing or new coupons pack).
      if (promotionalCode) return false
      if (os.prescriber_casting_fundings_for_customer) return false
      if (coupon || castingStoreGetCustomerBoughtCouponsPackInsights({ customer, offeredService: os }).remainingBoughtCouponsPacksQuantity !== 0) return false
      if (customerPlan || castingStoreAvailableCustomerPlanSubscriptions({ customer, offeredService }).length) return false

      return true
    }
    case 'message': return renderingMode !== 'widget'
    case 'attachments': return os?.rentable && os.allow_attachments
    case 'participants': return renderingMode === 'widget' && os?.require_participants_number
    case 'preferences': return os?.rentable && os.preferences.length > 0
    case 'tasks': return os?.rentable && renderingMode !== 'widget' && os.tasks.length > 0
    case 'combination-attributes': return os?.enable_combinations && castingStoreGetAllowedAttributesOfStep2(data).length > 0
    case 'combination-attributes-after-offered-service': return os?.enable_combinations && castingStoreGetAllowedAttributeJustAfterOfferedService(data).length > 0
    case 'backoffice-custom-price': return !!city && os?.casting_custom_price && backofficeSetCustomPriceWithoutQuotation
    case 'backoffice-appointment':
      return os?.enable_appointments_before_proposals
        && !backofficeSelectAssignableForSlots // disable in context of CreateEventWithCastingComponent
        && window.currentUser?.type === 'Operator'
        && !editedCastingId
        && slots.length > 0 && !slots.some(_ => !_.start_date)
    case 'price': return !!city && !!os && (!os.enable_groups || !!groupSessionSchedule) && (!!castingType || !castingStoreCanRenderCastingTypeInput(data))
  }
}

type CastingStoreCanRenderCastingTypeInputData = Pick<CastingStore['data'], 'offeredService' | 'castingType'>
export function castingStoreCanRenderCastingTypeInput ({ offeredService, castingType }: CastingStoreCanRenderCastingTypeInputData) {
  if (!offeredService?.rentable || offeredService.asap_only) return false

  const activeCastingTypes = (['casting_one_shot', 'casting_recurring'] as const).filter(value => offeredService[value])
  if (activeCastingTypes.length === 1 && activeCastingTypes[0] === castingType) return false

  return true
}

type CastingStoreGetWorkablesData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'requiredEmployees' | 'requiredSupplier' | 'serviceDeliveryLocation'>
export function castingStoreGetWorkables (data: CastingStoreGetWorkablesData, allowDiscardingMultiOpeningHours = true) {
  const { market, offeredService, requiredEmployees, requiredSupplier, serviceDeliveryLocation } = data
  const arrayOfWorkingDays: Openable[] = [offeredService.working_days.length ? offeredService : market]

  // if requiredEmployees is set, it pre-empts over requiredSupplier availabilities
  if (requiredEmployees.length) arrayOfWorkingDays.push(...requiredEmployees)
  else if (requiredSupplier) arrayOfWorkingDays.push(requiredSupplier)

  if (serviceDeliveryLocation) arrayOfWorkingDays.push(serviceDeliveryLocation)
  
  if (offeredService.rentable_unit_of_work === 'day' && allowDiscardingMultiOpeningHours) {
    // Discard multi_opening_hours because with only use working days (and later the existing events) to check availabilities.
    // For example, the customer may rent a resource (like a stand) for 3 days.
    // The resource may have opening hours, but they are ignored because the resource is rented on a daily basis.
    return arrayOfWorkingDays.map(workable => ({ working_days: workable.working_days, multi_opening_hours: fullfilledMultiOpeningHours }))
  }

  return arrayOfWorkingDays
}

type CastingStoreGetMultiOpeningHoursData = Pick<CastingStore['data'],  'market' | 'offeredService' | 'slots' | 'requiredEmployees' | 'requiredSupplier' | 'serviceDeliveryLocation'>
export function castingStoreGetMultiOpeningHours (data: CastingStoreGetMultiOpeningHoursData, { areAllowedPatternFrozen = false } = {}) {
  const { offeredService, slots } = data
  const numberOfMidnights = offeredService.rentable_unit_of_work === 'day' ? Math.ceil(offeredService.duration_max / (24 * 3600)) : 1
  const openables = castingStoreGetWorkables(data).map(openableUnserialize)

  // If the allowed_patterns are frozen at this step (set previously), we take them as a filter for the start date.
  // Typically, it is used on non complex recurring mode, where both 'frequency' and 'start_date' are accessed (in that order).
  // The customer chooses a pattern in the complex frquency screen, then pick a start_date that ensure allowed_patterns have a change to be available.
  if (areAllowedPatternFrozen) openables.push(openableFromCastingSlotAllowedPatterns(slots[0].allowed_patterns))

  const multiOpeningHoursUnsafeMidnight = openableReduce(openableIntersection(openables))
  const multiOpeningHours = openableOverMidnight(multiOpeningHoursUnsafeMidnight, numberOfMidnights)
  return { multiOpeningHoursUnsafeMidnight, multiOpeningHours }
}

type CastingStoreGetMinDurationData = Pick<CastingStore['data'], 'offeredService' | 'calculatorResult'>
export function castingStoreGetMinDuration ({ offeredService, calculatorResult }: CastingStoreGetMinDurationData) {
  return Math.max(offeredService.duration_min, calculatorResult || 0)
}

type CastingStoreGetMinDurationForFirstEventData = Pick<CastingStore['data'], 'offeredService' | 'calculatorResult' | 'calculatorResultFirstEvent' | 'castingType' | 'slots'>

/** Same as `getMinDuration()`, but for the first event of each slot. */
export function castingStoreGetMinDurationForFirstEvent (data: CastingStoreGetMinDurationForFirstEventData) {
  const { offeredService: os, castingType, calculatorResultFirstEvent, slots } = data
  if (!os || os.rentable_unit_of_work === 'day' || os.first_event_duration_strategy.type === 'none') return 0

  let minimumForFirstEvent = castingStoreGetMinDuration(data)
  const strategy = os.first_event_duration_strategy
  
  if (strategy.type === 'calculator') {
    minimumForFirstEvent = Math.max(minimumForFirstEvent, calculatorResultFirstEvent)
  } else if (strategy.type === 'fixed_minimum' && castingType === 'casting_recurring') {
    minimumForFirstEvent = Math.max(minimumForFirstEvent, strategy.value)
  } else if (strategy.type === 'coef_minimum' && castingType === 'casting_recurring') {
    const majoredFirstDuration = (slots[0]?.duration || 0) * (1 + strategy.value / 100)
    const majoredFirstDurationCeil = Math.ceil(majoredFirstDuration / os.duration_step) * os.duration_step
    minimumForFirstEvent = Math.max(minimumForFirstEvent, majoredFirstDurationCeil)
  }

  return minimumForFirstEvent
}

type CastingStoreGetMaxDurationData = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetMaxDuration (data: CastingStoreGetMaxDurationData) {
  const minOf = [data.offeredService.duration_max]
  const prescriberRemainingFundedHours = castingStoreGetPrescriberRemainingFundedHours(data)
  if (typeof prescriberRemainingFundedHours === 'number') minOf.push(prescriberRemainingFundedHours * 3600)
  return Math.min(...minOf)
}

type CastingStoreGetDurationForAllowedPatternData = Pick<CastingStore['data'], 'offeredService' | 'slots' | 'calculatorResult'>
export function castingStoreGetDurationForAllowedPattern ({ offeredService, slots, calculatorResult }: CastingStoreGetDurationForAllowedPatternData) {
  if (offeredService['customer_choose_end_date?']) return castingStoreGetMinDuration({ calculatorResult, offeredService })
  if (offeredService.max_slot_duration_per_employee) return Math.min(slots[0].duration, offeredService.max_slot_duration_per_employee)
  return slots[0].duration
}

type CastingStoreGetSingleRecurrenceDurationData = Pick<CastingStore['data'], 'slots' | 'selectedOptions' | 'offeredService'>

/** Returns the total duration for all slots and options for a single recurrence */
export function castingStoreGetSingleRecurrenceDuration (data: CastingStoreGetSingleRecurrenceDurationData) {
  return data.slots.reduce((acc, slot) => acc + slot.duration, 0) + castingStoreGetSelectedOptionDurationPerSlot(data) * data.slots.length
}

type CastingStoreFormatSingleRecurrenceDurationWithoutOptionsData = Pick<CastingStore['data'], 'slots' | 'offeredService'>

/** Useful to display total slot duration in casting header, depending on offered_service config. */
export function castingStoreFormatSingleRecurrenceDurationWithoutOptions ({ offeredService, slots }: CastingStoreFormatSingleRecurrenceDurationWithoutOptionsData) {
  if (offeredService?.rentable_unit_of_work === 'event') return i18nScoped.t('flat_rate')
  if (!slots.length) return ''
  return formatDurationFromSecs(slots.reduce((acc, curr) => acc + curr.duration, 0), { hideMinIfHours: true })
}

type CastingStoreFormatCalculatorContentData = Pick<CastingStore['data'], 'variableMetier' | 'slots' | 'offeredService'>
export function castingStoreFormatCalculatorContent (data: CastingStoreFormatCalculatorContentData) {
  const variableMetier = data.variableMetier
  if (!variableMetier || !Object.keys(variableMetier).length) return castingStoreFormatSingleRecurrenceDurationWithoutOptions(data)

  const calculatorI18nScoped = new I18nService(require('../../components/plugins/casting/duration/casting-duration-calculator-legacy.component.yml'))
  const fields = Object.values(variableMetier)[0].fields
  
  return Object.entries(fields)
    .filter(([, count]) => count > 0)
    .map(([fieldKey, count]) => calculatorI18nScoped.t(`inputs.${fieldKey}_input`, { count }))
    .join(', ')
}

type CastingStoreFormatSelectedOptionData = Pick<CastingStore['data'], 'market' | 'slots' | 'customer' | 'offeredService'>
export function castingStoreFormatSelectedOption ({ slots, market, offeredService, customer }: CastingStoreFormatSelectedOptionData, so: ReturnType<CastingStore['getSelectedOptionJoined']>[0], withName = false) {
  const displayPriceWithTax = castingStoreDisplayPriceWithTax({ customer, market, offeredService })
  const formattedQuantity = so.selectedOption.selected_value === 1 ? '' : `${ so.selectedOption.selected_value } x `
  
  // preverse the capitalization of the option name for DE (names always capitalized in German)
  const name = withName ? ` (${so.offeredOption.name[window.locale === 'de' ? 'toString' : 'toLocaleLowerCase']()})` : ''
  const perSlot = slots.length > 1 ? i18nScoped.t('per_slot') : ''

  switch (so.offeredOption.option_type) {
    case 'product_catalogue': {
      const unitPriceObj = so.offeredOptionOfferedService.offered_service.unit_price
      const unitPrice = unitPriceObj ? +unitPriceObj[displayPriceWithTax ? 'with_tax' : 'without_tax'] : 0
      return `+${ formattedQuantity } ${ currencyFormat(market.currency, unitPrice.toFixed(2)) }${name}`
    }
    case 'given_quantity': {
      const unitPriceObj = so.offeredOption.fixed_price_from
      const unitPrice = unitPriceObj ? +unitPriceObj[displayPriceWithTax ? 'with_tax' : 'without_tax'] : 0
      return `+${ formattedQuantity } ${ currencyFormat(market.currency,unitPrice.toFixed(2)) } ${perSlot}${name}`
    }
    case 'given_duration': return `+${ formatDurationFromSecs(so.selectedOption.selected_value) } ${perSlot}${name}`
  }
}

type CastingStoreGetMinStartDateData = Pick<CastingStore['data'], 'offeredService' | 'backofficeAllowToStartInPast' | 'backofficeSkipsWaitingOrderHoursPeriod'>
export function castingStoreGetMinStartDate (data: CastingStoreGetMinStartDateData) {
  const { offeredService, backofficeAllowToStartInPast, backofficeSkipsWaitingOrderHoursPeriod } = data
  const dates = []

  if (backofficeAllowToStartInPast) {
    // operators, through the CreateEventWithCastingComponent, can create casting in the past and generate events immediately
    dates.push(moment().subtract(6, 'month').startOf('month'))
  } else if (backofficeSkipsWaitingOrderHoursPeriod) {
    dates.push(moment().add(1, 'h'))
  } else {
    dates.push(moment().add(offeredService.waiting_order_hours_period, 'h'))
  }
  
  // if the prescriber is funding hours, the start date of the prescriber_casting_funding matters
  dates.push(castingStoreGetPrescriberCastingFundingStartDate(data))
  
  return moment.max(dates.filter(date => date !== null))
}

type CastingStoreGetMaxStartDateData = Pick<CastingStore['data'], 'offeredService' | 'customerPlanSubscriptionExpirationAction' | 'customer'>
export function castingStoreGetMaxStartDate (data: CastingStoreGetMaxStartDateData) {
  let minOf: moment.Moment[] = [castingStoreGetPrescriberPrescriberCastingFundingEndDate(data)]

  if (data.customerPlanSubscriptionExpirationAction?.expiration_action === 'cancel_events') {
    const cps = data.customer.customer_plan_subscriptions.find(_ => _.id === data.customerPlanSubscriptionExpirationAction.id)
    minOf.push(moment(cps.expires_at))
  }

  minOf = minOf.filter(Boolean)
  return minOf.length ? moment.min(minOf) : null 
}

type CastingStoreGetMinRecurrenceEndDateData = Pick<CastingStore['data'], 'slots'>
export function castingStoreGetMinRecurrenceEndDate ({ slots }: CastingStoreGetMinRecurrenceEndDateData) {
  return moment(slots[0].start_date).add(14, 'days')
}

type CastingStoreGetMaxRecurrenceEndDateData = Pick<CastingStore['data'], 'offeredService' | 'selectedOptions' | 'slots' | 'castingType' | 'calculatorResult' | 'groupSessionSchedule'>
export function castingStoreGetMaxRecurrenceEndDate (data: CastingStoreGetMaxRecurrenceEndDateData) {
  let minOf: moment.Moment[] = [castingStoreGetPrescriberPrescriberCastingFundingEndDate(data)]

  if (typeof castingStoreGetPrescriberCastingFundingRef(data) === 'string') {
    const prescriberRemainingFundedHours = castingStoreGetPrescriberRemainingFundedHours(data)

    if (typeof prescriberRemainingFundedHours === 'number') {
      const maxOccurrences = castingStoreSimulateOccurrencesUpToMaxAllowedDuration(data, prescriberRemainingFundedHours, { end_date: null })
      if (maxOccurrences.length) minOf.push(maxOccurrences[maxOccurrences.length - 1].at)
    }
  }

  // groupSessionSchedule.end_date has a time precision, and stop right before the beginning of the next occurrence when built by ogustine.
  if (data.groupSessionSchedule) minOf.push(moment(data.groupSessionSchedule.end_date).subtract(1, 'day'))

  minOf = minOf.filter(Boolean)
  return minOf.length ? moment.min(minOf) : null
}

type CastingStoreIsStartDayDisabledData = Pick<CastingStore['data'], 'market' | 'city' | 'slots' | 'offeredService' | 'backofficeSelectAssignableForSlots' | 'castingType' | 'calculatorResult' | 'requiredPlace' | 'serviceDeliveryLocation' | 'backofficeAllowToStartInPast' | 'backofficeSkipsWaitingOrderHoursPeriod' | 'enableLodging' | 'requiredEmployees' | 'customerPlanSubscriptionExpirationAction' | 'customer'>
export function castingStoreIsStartDayDisabled (
  data: CastingStoreIsStartDayDisabledData,
  store: CastingStore,
  date: Date,
  multiOpeningHours: UnserializedMultiOpeningHours & { reduced: true, midnightSafe: true },
  opts: { duration?: number, allowedPatterns?: CastingSlot['allowed_patterns'], tracingContainer?: StartDayDisabledTracing[] } = {}
) {
  const { slots, offeredService } = data
  date = new Date(date) // work an a copy to prevent any side effect
  date.setHours(0, 0, 0, 0)

  const hasDayOffAtDate = castingStoreHasDayOffAtDate(data, date)
  opts.tracingContainer?.push({ status: hasDayOffAtDate ? 'fail' : 'pass', summary: i18nScoped.t('is_start_date_disabled.has_day_off_at_date') })
  if (hasDayOffAtDate) return true

  if (isSameDay(date, new Date())) {
    opts.tracingContainer?.push({ status: 'info', summary: i18nScoped.t('is_start_date_disabled.is_today') })

    // react-date-picker can send a date which does not exactly reflect the current time. But is this required for this.isBeforeWaitingPeriod(date).
    date.setHours(new Date().getHours(), new Date().getMinutes(), 0, 0)

    // The slots could be already defined (ex. for complex recurring, slots are chosen before start_date).
    // Scenario: Today is monday at 10h. Customer choosed 'every monday from 8h to 9h' in complex mode. Today should not be allowed as a start date for the recurrence.
    const ealierStartHourFromAllowedPatterns = slots
      .flatMap(slot => slot.allowed_patterns)
      .filter(allowedPattern => allowedPattern.day_id === date.getDay() && allowedPattern.from_hour)
      .map(allowedPattern => parseTime(allowedPattern.from_hour))
      .sort((hourA, hourB) => hourA - hourB)[0]

    // With date set has this, the current day will be rejected if before this.getMinStartDate() (later in this function)
    if (typeof ealierStartHourFromAllowedPatterns !== 'undefined') date.setHours(Math.ceil(ealierStartHourFromAllowedPatterns), 0, 0, 0)
  }

  // in case of complex with complex_duration_different_than_range, slot duration is no more relevant since slot can be splited in various people...
  const isComplexWithPotentialTeams = castingStoreIsComplex(data) && offeredService.complex_duration_different_than_range
  const minOpenedDuration = opts.duration || (isComplexWithPotentialTeams ? Math.min(castingStoreGetDurationForAllowedPattern(data), 3 * 3600) : castingStoreGetDurationForAllowedPattern(data))
  if (isComplexWithPotentialTeams) opts.tracingContainer?.push({ status: 'info', summary: i18nScoped.t('is_start_date_disabled.is_complex_with_potential_teams') })
  opts.tracingContainer?.push({ status: 'info', summary: i18nScoped.t('is_start_date_disabled.min_opened_duration', { min_duration: formatDurationFromSecs(minOpenedDuration) }) })

  // check realtime availabilties of employees or resources, only if realtime is enabled.
  const realTimeFailed = castingStoreIsRealTime(data) && !castingStoreHasRealTimeAvailabilityAtDay(data, store, date, minOpenedDuration, multiOpeningHours)
  opts.tracingContainer?.push({ status: realTimeFailed ? 'fail' : 'pass', summary: i18nScoped.t('is_start_date_disabled.real_time_fails') })
  if (realTimeFailed) return true

  // check if there is any possible start hour based on multi opening hours
  const startHours = openableStartHours(multiOpeningHours, minOpenedDuration / 3600)[openableDateToWorkingDay(date)]
  opts.tracingContainer?.push({ status: startHours.length ? 'pass' : 'fail', summary: i18nScoped.t('is_start_date_disabled.range_found_in_multi_opening_hours') })
  if (!startHours.length) return true
  
  // compare the last possible start hour to waiting period.
  date.setHours(Math.max(Math.min(Math.ceil(startHours[startHours.length - 1][1] - minOpenedDuration / 3600), 23), 0), 0, 0, 0)

  // check the min start date
  const minStartDate = castingStoreGetMinStartDate(data)
  const minStartDateFails = moment(date).isBefore(minStartDate)
  opts.tracingContainer?.push({
    status: minStartDateFails ? 'fail' : 'pass',
    summary: i18nScoped.t(
      `is_start_date_disabled.min_start_date${data.backofficeSkipsWaitingOrderHoursPeriod ? '_skip_waiting_hours' : ''}`, 
      { min_start_date: minStartDate.format('ll'), waiting_hours: offeredService.waiting_order_hours_period }
    )
  })
  if (minStartDateFails) return true

  // check the max start date
  const maxStartDate = castingStoreGetMaxStartDate(data)
  if (maxStartDate) {
    const maxStartDateFails = maxStartDate?.isBefore(date)
    opts.tracingContainer?.push({ status: maxStartDateFails ? 'fail' : 'pass', summary: i18nScoped.t('is_start_date_disabled.max_start_date', { max_start_date: maxStartDate.format('ll') }) })
    if (maxStartDateFails) return true
  }

  return false
}

export function castingStoreGetFirstEnabledDateFrom (startingFromDate: Date, isDisabled: (date: Date) => boolean) {
  const returnedDate = moment(startingFromDate).toDate()

  while (isDisabled(returnedDate) && returnedDate.getTime() - Date.now() < 2 * 30 * 24 * 3600 * 1000) {
    returnedDate.setDate(returnedDate.getDate() + 1)
  }

  return returnedDate
}

type CastingStoreIsRealTimeData = Pick<CastingStore['data'], 'market' | 'city' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreIsRealTime (data: CastingStoreIsRealTimeData) {
  const { city, offeredService, castingType } = data
  return city && offeredService?.real_time_planning && !!castingType && offeredService.rentable_unit_of_work !== 'day' && !castingStoreIsComplex(data)
}

type CastingStoreIsReadyForSubmitPluginData = Pick<CastingStore['data'], 'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'quantity' | 'cityResults' | 'serviceCategory' | 'requiredPlace' | 'calculatorResult' | 'selectedOptions' | 'serviceDeliveryLocation' | 'serviceDelivery' | 'selectedCombinationAttrs' | 'attachments' | 'asapOffer' | 'complexVariantMonoSlotMultiAllowedPatterns' | 'backofficeSetCustomPriceWithoutQuotation' | 'overrideRatePriceCents' | 'quotation' | 'lodging' | 'enableLodging' | 'lodgingIcalPlatform' | 'coupon' | 'promotionalCode' | 'appointmentRequiredRanges' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'selectedQuantityDiscount' | 'customerPlan' | 'customerPlanSubscriptionExpirationAction' | 'customerPlanSubscriptionRemovePendingId'>
export function castingStoreIsReadyForSubmitPlugin (data: CastingStoreIsReadyForSubmitPluginData, store: CastingStore) {
  // check if every focusable step is properly fullfilled.
  return !focusedInputs.find(focusedInput => castingStoreCanFocus({ ...data, focusedInputBlacklist: [] }, focusedInput) && castingStoreGetProgressForStep(data, store, focusedInput) !== 100)
}

type CastingStoreIsComplexData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreIsComplex ({ market, offeredService, castingType, backofficeSelectAssignableForSlots, enableLodging }: CastingStoreIsComplexData) {
  if (!castingType) return false
  if (enableLodging) return false
  if (!offeredService || offeredService.rentable_unit_of_work === 'day' || offeredService.enable_groups) return false
  if (backofficeSelectAssignableForSlots) return true
  return market['complex_planning?'] && offeredService[castingType === 'casting_recurring' ? 'complex_recurrences' : 'complex_one_shots']
}

type CastingStoreIsComplexDurationDifferentThanRangeAllowedData = Pick<CastingStore['data'], 'offeredService' | 'backofficeSelectAssignableForSlots'>
export function castingStoreIsComplexDurationDifferentThanRangeAllowed ({ offeredService, backofficeSelectAssignableForSlots }: CastingStoreIsComplexDurationDifferentThanRangeAllowedData) {
  return offeredService.complex_duration_different_than_range && !backofficeSelectAssignableForSlots
}

type CastingStoreIsAllowingAnyTimeData = Pick<CastingStore['data'], 'slots'>
export function castingStoreIsAllowingAnyTime ({ slots }: CastingStoreIsAllowingAnyTimeData) {
  return slots.length === 1 && castingsSlotAllowingAnyTimeOn7Days(slots[0])
}

type CastingStoreHasRealTimeAvailabilityAtDayData = Pick<CastingStore['data'], 'offeredService' | 'castingType' | 'city' | 'slots' | 'requiredPlace' | 'serviceDeliveryLocation' | 'enableLodging' | 'requiredEmployees'>

/**
 * @param datetimeDuringDay could be in the middle of the day, used to check if an avaiaiblity
 *  starts the same day starting from this time. This allows to find availabilities for today,
 *  while a part of the day is already gone.
 * 
 * @param minDurationInSeconds the min duration to look for.
 *
 * @param multiOpeningHours if set, the found availability should be included in the multiOpeningHours.
 *  Working days and multi opening hours of the employee/resource are already integrated inside the availabilties (computed server-side).
 *  But contrains may be known only in frontend (ex. requiredSupplier, already set allowed patterns at a previous step, etc.)
 */
export function castingStoreHasRealTimeAvailabilityAtDay (data: CastingStoreHasRealTimeAvailabilityAtDayData, store: CastingStore, datetimeDuringDay: Date, minDurationInSeconds: number, multiOpeningHours?: UnserializedMultiOpeningHours) {
  const realTimeAvailabilities = castingStoreGetRealTimeAvailabilities(data, store)

  // realtime availabilities are not yet loaded (XHR probably pending, any other reason is probably a bug).
  if (!realTimeAvailabilities) return false

  const workingDay = openableDateToWorkingDay(datetimeDuringDay)
  const mohMomentRange = (multiOpeningHours ? multiOpeningHours[workingDay] : []).map(moh =>
    moment.range(
      moment(datetimeDuringDay).hours(moh[0]).minutes(moh[0] * 60 % 60).seconds(0).milliseconds(0),
      moment(datetimeDuringDay).hours(moh[1]).minutes(moh[1] * 60 % 60).seconds(0).milliseconds(0)
    )
  )

  for (const rtForOneAssignable of realTimeAvailabilities) {
    const found = rtForOneAssignable.find(range =>
      range.start.isSame(datetimeDuringDay, 'day') &&
      range.start.valueOf() >= datetimeDuringDay.valueOf() &&
      range.diff('seconds') >= minDurationInSeconds &&

      // check that the common period between multiopeningHours and the range contains the minDurationInSeconds (warning: empty intersection may return `null`).
      (!multiOpeningHours || mohMomentRange.find(mohRange => mohRange.intersect(range)?.diff('seconds') >= minDurationInSeconds))
    )

    if (found) return true
  }

  return false
}

type CastingStoreGetSelectedOptionJoinedData = Pick<CastingStore['data'], 'selectedOptions' | 'offeredService'>
export function castingStoreGetSelectedOptionJoined ({ selectedOptions, offeredService }: CastingStoreGetSelectedOptionJoinedData) {
  if (!offeredService) return []

  return selectedOptions.map(selectedOption => {
    const offeredOption = offeredService.offered_options.find(_ => _.id === selectedOption.offered_option_id)
    const offeredOptionOfferedService = 'offered_option_offered_services' in offeredOption && offeredOption.offered_option_offered_services.find(_ => _.offered_service.id === selectedOption.offered_service_id)
    return { selectedOption, offeredOption, offeredOptionOfferedService }
  })
}

type CastingStoreGetSelectedOptionDurationPerSlotData = Pick<CastingStore['data'], 'selectedOptions' | 'offeredService'>

/** Returns the additionnal duration for each slot caused by options */
export function castingStoreGetSelectedOptionDurationPerSlot (data: CastingStoreGetSelectedOptionDurationPerSlotData) {
  return castingStoreGetSelectedOptionJoined(data)
    .filter(_ => _.offeredOption.option_type === 'given_duration')
    .reduce((acc, curr) => acc + curr.selectedOption.selected_value, 0)
}

type CastingStoreGetSelectedOptionPriceData = Pick<CastingStore['data'], 'selectedOptions' | 'offeredService' |'slots' | 'market' | 'customer'>

/** Returns the additionnal price for all slots (options adding price added to each slot, product catalogue added only once) */
export function castingStoreGetSelectedOptionPrice (data: CastingStoreGetSelectedOptionPriceData) {
  const displayPriceWithTax = castingStoreDisplayPriceWithTax(data)

  return castingStoreGetSelectedOptionJoined(data)
    .map(({ offeredOption, selectedOption, offeredOptionOfferedService }) => {
      switch (offeredOption.option_type) {
        case 'product_catalogue': {
          const unitPriceObj = offeredOptionOfferedService.offered_service.unit_price
          const unitPrice = unitPriceObj ? +unitPriceObj[displayPriceWithTax ? 'with_tax' : 'without_tax'] : 0
          return selectedOption.selected_value * unitPrice
        }
        case 'given_quantity': {
          const unitPrice = offeredOption.fixed_price_from ? +offeredOption.fixed_price_from[displayPriceWithTax ? 'with_tax' : 'without_tax'] : 0
          return data.slots.length * selectedOption.selected_value * unitPrice
        }
        case 'given_duration': return 0
      }
    })
    .reduce((acc, curr) => acc + curr, 0)
}

type CastingStoreDisplayPriceWithTaxData = Pick<CastingStore['data'], 'offeredService' | 'customer' | 'market'>

/** Returns true if the prices should be displayed tax inclusive, and false otherwise. */
export function castingStoreDisplayPriceWithTax ({ customer, offeredService, market }: CastingStoreDisplayPriceWithTaxData) {
  if (customer) {
    return market[customer.corporate_name ? 'display_price_with_tax_to_corporate' : 'display_price_with_tax_to_individual']
  } else if (offeredService?.allowed_customer_kinds.length === 1) {
    return market[offeredService.allowed_customer_kinds[0] === 'corporate' ? 'display_price_with_tax_to_corporate' : 'display_price_with_tax_to_individual']
  } else {
    return market.display_price_with_tax_to_individual
  }
}

type CastingStoreGetUnaplicableSpecificPricesForEstimateData = Pick<CastingStore['data'], 'castingType' | 'city' | 'slots'>

/**
 * Returns an array of specifc_price_rule.rule.type that cannot be used to
 * compute the estimative casting price, depending on the not yet filled steps and inputs.
 * 
 * For example, it does not make sens to consider prices depending on the day of the week if allowed patterns are missing.
 */
export function castingStoreGetUnaplicableSpecificPricesForEstimate ({ castingType, city, slots }: CastingStoreGetUnaplicableSpecificPricesForEstimateData) {
  const hasStartDate = !!slots[0]?.start_date
  const hasDuration = typeof slots[0]?.duration === 'number'
  const hasTimes = slots.length > 0 && slots[0].allowed_patterns.length > 0

  const applicableStatusPerRuleType: Record<SpecificPriceRuleBase['rule']['type'], boolean> = {
    recurring_or_one_shot_only: !!castingType,
    weeks_interval: !!slots[0]?.weeks_interval,
    between_dates: hasStartDate,
    day_off: hasStartDate,
    week_days: hasStartDate,
    min_duration_per_event: hasDuration,
    min_duration_per_week: hasDuration,
    range_hour: hasTimes,
    zone: !!city
  }

  return Object.entries(applicableStatusPerRuleType).filter(_ => !_[1]).map(_ => _[0]) as SpecificPriceRuleBase['rule']['type'][]
}

type CastingStorePreparePendingSlotsForSimulationData = Pick<CastingStore['data'], 'offeredService' | 'castingType' | 'slots' | 'calculatorResult'>

/**
 * Slots may be incomplete until the customer picked a start-date and an allowed pattern.
 * Those slots cannot be used as this to simulate events. Instead, we need some placeholder, so the code will not crash.
 * Additionnally, some attributes may be overriden to simulate other scenario, like the end_date.
 */
export function castingStorePreparePendingSlotsForSimulation (data: CastingStorePreparePendingSlotsForSimulationData, overrides: { end_date?: string } = {}) {
  const { offeredService, castingType } = data
  const slots = data.slots.length ? data.slots : [castingStoreBuildSlotWithDuration(data, castingStoreGetMinDuration(data))]

  return slots.map(slot => {
    const newSlot = {
      ...slot,
      end_date: 'end_date' in overrides ? overrides.end_date : slot.end_date,
      start_date: slot.start_date || moment().format('YYYY-MM-DD'),
      weeks_interval: slot.weeks_interval || (castingType === 'casting_one_shot' ? null : 1)
    }

    if (!newSlot.allowed_patterns.length) {
      newSlot.allowed_patterns = [{
        day_id: moment(newSlot.start_date).day(),
        additional_days: offeredService.rentable_unit_of_work === 'day' ? 1 : null,
        from_hour: null,
        until_hour: null
      }]
    }

    // until_hour could be null if os.customer_choose_end_date?, so we set it to prevent crashing the app in simulation mode
    newSlot.allowed_patterns = newSlot.allowed_patterns.map(allowedPattern => {
      const newAllowedPattern = { ...allowedPattern }
      newAllowedPattern.from_hour ||= '08:00'

      if (offeredService.rentable_unit_of_work === 'day') newAllowedPattern.until_hour ||= '18:00'
      newAllowedPattern.until_hour ||= formatTime((parseTime(newAllowedPattern.from_hour) + slot.duration / 3600) % 24)

      return newAllowedPattern
    })

    return newSlot
  })
}

type CastingStoreSimulateFirstOccurrencesData = Pick<CastingStore['data'], 'selectedOptions' | 'offeredService' | 'castingType' | 'slots' | 'calculatorResult'>

/**
 * Compute a list of occurrences, sorted by date ASC and based on the slots recurrences.
 * This method supports partial information during estimation, such as missing start_date, weeks_interval or allowed_patterns.
 */
export function castingStoreSimulateFirstOccurrences (data: CastingStoreSimulateFirstOccurrencesData,limit: number, overrides: { end_date?: string } = {}) {
  const optionDuration = castingStoreGetSelectedOptionDurationPerSlot(data)
  const patchedSlots = castingStorePreparePendingSlotsForSimulation(data, overrides)

  // before submission (and server-side persistence), slots duration does not contain the option's duration
  return castingSimulateFirstEventsFromUnfinalizedCasting({ casting: { slots: patchedSlots }, offeredService: data.offeredService, limit })
    .map(_ => ({ at: _.startDate, durationWithOptions: _.duration + optionDuration }))
}

type CastingStoreSimulateOccurrencesUpToMaxAllowedDurationData =  Pick<CastingStore['data'], 'selectedOptions' | 'offeredService' | 'castingType' | 'calculatorResult' | 'slots'>
export function castingStoreSimulateOccurrencesUpToMaxAllowedDuration (data: CastingStoreSimulateOccurrencesUpToMaxAllowedDurationData, allowedHours: number, overrides: { end_date?: string } = {}) {
  const occurrences = takeWhile(
    castingStoreSimulateFirstOccurrences(data, 20, overrides),
    (sum, occ, i, array) => sum + occ.durationWithOptions > allowedHours * 3600 && !array[i - 1]?.at.isSame(occ.at, 'day') ? false : sum + occ.durationWithOptions,
    0
  )
  
  // `takeWhile` enumerates occurences on a day by day basis. If the total duration is higher than allowed, we drop all occurrences related to the last day.
  if (occurrences.reduce((acc, curr) => acc + curr.durationWithOptions, 0) > allowedHours * 3600) {
    const lastDay = occurrences.pop().at
    while (occurrences[occurrences.length - 1].at.isSame(lastDay, 'day')) occurrences.pop()
  }

  return occurrences
}

type CastingStoreGetCustomerBoughtCouponsPackInsightsData = Pick<CastingStore['data'], 'customer' | 'offeredService'>
export function castingStoreGetCustomerBoughtCouponsPackInsights ({ customer, offeredService }: CastingStoreGetCustomerBoughtCouponsPackInsightsData) {
  // When creating a new customer at the last step, the customer payload returned by the server on registration
  // may not contain the bought_coupons_packs nor the customerCouponsPacksSimulationResult attributes.
  const customerBoughtCouponsPacks = customer?.bought_coupons_packs?.filter(_ => _.paid_at && _.offered_services.some(os => os.id === offeredService.id)) || []
  const quantityLeftForBoughtCouponsPacks = customer?.customerCouponsPacksSimulationResult?.quantityLeftForBoughtCouponsPacks || []
  const simulatedBoughtCouponsPacksComsuptions = customerBoughtCouponsPacks.map(boughtCouponsPack => boughtCouponsPackConsumptionInsights(quantityLeftForBoughtCouponsPacks, boughtCouponsPack))
  
  const totalBoughtCouponsPacksUsed = simulatedBoughtCouponsPacksComsuptions.reduce((acc, val) => acc + val.quantityUsed, 0)
  const totalBoughtCouponsPacksPlanned = simulatedBoughtCouponsPacksComsuptions.reduce((acc, val) => acc + val.simulatedIncomingQuantityPlanned, 0)
  const totalBoughtCouponsPacksQuantity = customerBoughtCouponsPacks.reduce((acc, val) => acc + val.coupons_pack.quantity, 0)
  const remainingBoughtCouponsPacksQuantity = simulatedBoughtCouponsPacksComsuptions.reduce((acc, val) => acc + val.simulatedQuantityLeft, 0)

  return { totalBoughtCouponsPacksUsed, totalBoughtCouponsPacksPlanned, totalBoughtCouponsPacksQuantity, remainingBoughtCouponsPacksQuantity }
}

type CastingStoreGetPrescriberCastingFundingRefData = Pick<CastingStore['data'], 'offeredService'>

/**
 * The customer may have multiple prescriber_casting_fundings created by its prescriber.
 * A casting can cummulate multiple subscriptions if they all share the same reference.
 * References are strings used as keys of the this.data.offeredService.prescriber_casting_fundings_for_customer object.
 * 
 * TODO: do not take the first found reference anymore, but ask to the customer to choose one.
 */
export function castingStoreGetPrescriberCastingFundingRef ({ offeredService }: CastingStoreGetPrescriberCastingFundingRefData) {
  const subscriptionsByRef = offeredService?.prescriber_casting_fundings_for_customer
  return (subscriptionsByRef && Object.keys(subscriptionsByRef)[0]) ?? null
}

type CastingStoreGetPrescriberPrescriberCastingFundingEndDate = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetPrescriberPrescriberCastingFundingEndDate (data: CastingStoreGetPrescriberPrescriberCastingFundingEndDate) {
  const ref = castingStoreGetPrescriberCastingFundingRef(data)
  if (typeof ref !== 'string') return null

  return moment.min(data.offeredService.prescriber_casting_fundings_for_customer[ref].map(_ => moment(_.end_date)))
}

type CastingStoreGetPrescriberCastingFundingStartDateData = Pick<CastingStore['data'], 'offeredService'>

/**
 * The customer can book now while its subscription has not yet started.
 * In such cases, the first event should be inside the prescriber_casting_fundings validity period.
 */
export function castingStoreGetPrescriberCastingFundingStartDate (data: CastingStoreGetPrescriberCastingFundingStartDateData) {
  const ref = castingStoreGetPrescriberCastingFundingRef(data)
  if (typeof ref !== 'string') return null

  return moment.max(data.offeredService.prescriber_casting_fundings_for_customer[ref].map(_ => moment(_.start_date)))
}

type CastingStoreGetPrescriberRemainingFundedHoursData = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetPrescriberRemainingFundedHours (data: CastingStoreGetPrescriberRemainingFundedHoursData) {
  const ref = castingStoreGetPrescriberCastingFundingRef(data)
  if (typeof ref !== 'string') return null
  return data.offeredService.prescriber_casting_fundings_for_customer[ref].reduce((acc, curr) => acc + curr.remaining, 0)
}

type CastingStoreGetPrescriberCastingFundingsData = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetPrescriberCastingFundings (data: CastingStoreGetPrescriberCastingFundingsData) {
  const ref = castingStoreGetPrescriberCastingFundingRef(data)
  return typeof ref === 'string' ? data.offeredService.prescriber_casting_fundings_for_customer[ref] : []
}

type CastingStoreGetServiceDeliveryRequiredKeysData = Pick<CastingStore['data'], 'customer' | 'requiredPlace'>
export function castingStoreGetServiceDeliveryRequiredKeys ({ customer, requiredPlace }: CastingStoreGetServiceDeliveryRequiredKeysData) {
  const baseKeys = ['city', 'country', 'street', 'zipcode', ...(customer.corporate_name ? ['corporate_name'] as const : ['civility', 'first_name', 'last_name'] as const)] as const
  const billingKeys: (keyof CastingStore['data']['serviceDelivery'])[] = baseKeys.map(key => `billing_${key}` as const)
  const deliveryKeys: (keyof CastingStore['data']['serviceDelivery'])[] = requiredPlace === 'customers_place' ? baseKeys.map(key => `delivery_${key}` as const) : []
  return billingKeys.concat(deliveryKeys)
}

type CastingStoreGetAllowedAttributeJustAfterOfferedService = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetAllowedAttributeJustAfterOfferedService (data: CastingStoreGetAllowedAttributeJustAfterOfferedService) {
  return data.offeredService.allowed_offered_service_attrs.filter(_ => _.ask_immediately_after_offered_service)
}

type CastingStoreCastingStoreGetAllowedAttributesOfStep2Data = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreGetAllowedAttributesOfStep2 (data: CastingStoreCastingStoreGetAllowedAttributesOfStep2Data) {
  return data.offeredService.allowed_offered_service_attrs.filter(_ => !_.ask_immediately_after_offered_service)
}

type CastingStoreGetServiceDeliveryLocationsData = Pick<CastingStore['data'], 'city' | 'market' | 'editedCastingId' | 'renderingMode' | 'offeredService' | 'slots' | 'customer' | 'backofficeSelectCustomer' | 'castingType' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'selectedCombinationAttrs' | 'backofficeSetCustomPriceWithoutQuotation' | 'enableLodging' | 'lodging' | 'coupon' | 'promotionalCode' | 'serviceDeliveryLocation' | 'requiredPlace' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'customerPlan'>
export function castingStoreGetServiceDeliveryLocations (data: CastingStoreGetServiceDeliveryLocationsData) {
  let serviceDeliveryLocations = data.offeredService.service_delivery_locations

  if (castingStoreCanFocus(data, 'combination-attributes-after-offered-service')) {
    // AllowedAllowedOfferedServiceAttr returned by this.getAllowedAttributeJustAfterOfferedService() are set before service_delivery_location is chosen.
    // Depending on the selected attributes for there allowed attributes, more or less combinations are available.
    // The list of service_delivery_location is then reduced based on the stocks of each possible combination.
    // AllowedAllowedOfferedServiceAttr returned by this.getAllowedAttributesOfStep2() should be ignored (because there are set later in step 2).
    const sdlIds = castingStoreGetCombinationsMatchingSelectedAttrs(data, castingStoreGetAllowedAttributesOfStep2(data).map(_ => _.id))
      .flatMap(combination => combination.offered_service_stocks)
      .flatMap(stock => stock.service_delivery_location_id)

    serviceDeliveryLocations = serviceDeliveryLocations.filter(_ => sdlIds.includes(_.id))
  }

  return serviceDeliveryLocations
}

type CastingStoreGetCombinationsMatchingSelectedAttrsData = Pick<CastingStore['data'], 'offeredService' |'selectedCombinationAttrs'>
export function castingStoreGetCombinationsMatchingSelectedAttrs (data: CastingStoreGetCombinationsMatchingSelectedAttrsData, ignoredAllowedAttrIds: TypedID<'AllowedOfferedServiceAttr'>[]) {
  const { offeredService: { offered_service_combinations: combinations }, selectedCombinationAttrs } = data

  return combinations.filter(combination => {
    for (const choice of selectedCombinationAttrs) {
      if (
        !choice._destroy &&
        !ignoredAllowedAttrIds.includes(choice.allowed_offered_service_attr_id) &&
        !combination.offered_service_combination_attrs.find(_ => _.values.includes(choice.value))
      ) {
        return false
      }
    }

    return true
  })
}

type CastingStoreGetTabsForOfferedServiceDescriptionData = Pick<CastingStore['data'], 'offeredService' | 'market'>
export function castingStoreGetTabsForOfferedServiceDescription ({ offeredService, market }: CastingStoreGetTabsForOfferedServiceDescriptionData) {
  const descriptionFile = offeredService.description_file || market.description_file
  const descriptionFilename = offeredService.description_filename || market.description_filename
  const tabs = []

  if ((offeredService.description && !offeredService.description_hide) || (descriptionFile && descriptionFilename)) {
    tabs.push({ content: i18nScoped.t('description') as string, value: 0 })
  }

  if (offeredService.description_image.url) {
    tabs.push({ content: i18nScoped.t('photo') as string, value: 1 })
  }

  return tabs
}

type CastingStoreHasErrorData = Pick<CastingStore['data'], 'errors'>
export function castingStoreHasError ({ errors }: CastingStoreHasErrorData, fieldName: string) {
  return errors?.errors && errors.errors[fieldName]?.length > 0
}

type CastingStoreGetStepTitleData = Pick<CastingStore['data'], 'market' | 'castingType' | 'offeredService' | 'backofficeSelectAssignableForSlots' | 'enableLodging' | 'requiredPlace'>
export function castingStoreGetStepTitle (data: CastingStoreGetStepTitleData, step: CastingStore['data']['focusedInput']): string {
  const { castingType, offeredService, enableLodging, requiredPlace } = data

  switch(step) {
    case 'backoffice-customer': return i18nScoped.t('steps_title.customer')
    case 'city': return i18nScoped.t('steps_title.city')
    case 'offered-service': return i18nScoped.t('steps_title.service')
    case 'enable-lodging': return i18nScoped.t( 'steps_title.enable_lodging')
    case 'lodging': return i18nScoped.t('steps_title.lodging')
    case 'lodging-ical': return i18nScoped.t('steps_title.lodging_ical')
    case 'lodging-check-in-out': return i18nScoped.t('steps_title.lodging_check_in_out')
    case 'required-place': return i18nScoped.t('steps_title.required_place')
    case 'quantity': return i18nScoped.t('steps_title.quantity')
    case 'customer-plan': return i18nScoped.t('steps_title.customer_plan')
    case 'coupon': return i18nScoped.t('steps_title.coupon')
    case 'quantity-discount': return i18nScoped.t('steps_title.quantity_discount')
    case 'combination-attributes':
    case 'combination-attributes-after-offered-service':  {
      if (!offeredService) return i18nScoped.t('steps_title.combination_attributes')
      const allowedAttrs = step === 'combination-attributes' ? castingStoreGetAllowedAttributesOfStep2(data) : castingStoreGetAllowedAttributeJustAfterOfferedService(data)
      return allowedAttrs.length === 1 ? allowedAttrs[0].offered_service_attr.name : i18nScoped.t('steps_title.combination_attributes')
    }
    case 'group-session': return i18nScoped.t('steps_title.group_session')
    case 'complex-variant': return i18nScoped.t('steps_title.complex_variant')
    case 'duration': return i18nScoped.t('steps_title.duration')
    case 'complex': return i18nScoped.t(`steps_title.${castingType === 'casting_recurring' ? 'frequency' : 'planning'}`)
    case 'frequency': return i18nScoped.t('steps_title.frequency')
    case 'start-date':
      if (castingStoreIsComplex(data) || enableLodging) return i18nScoped.t('steps_title.start_date')

      if (offeredService?.no_start_time_nor_duration_asked_to_customer) {
        return offeredService.flexible_start_date_in_absence_of_start_time_and_duration
          ? i18nScoped.t('steps_title.date_no_time_preference')
          : i18nScoped.t('steps_title.date_no_time')
      }

      return i18nScoped.t('steps_title.date_and_time')
    case 'end-date': return i18nScoped.t('steps_title.end_date')
    case 'options': return i18nScoped.t('steps_title.options')
    case 'backoffice-service-delivery': return i18nScoped.t(offeredService.buyable || requiredPlace === 'customers_place'  ? 'steps_title.service_delivery' : 'steps_title.service_delivery_billing_only')
    case 'message': return i18nScoped.t('steps_title.message')
    case 'participants': return i18n('casting_steps.step_2.inputs.participants_number_label') // Use the legacy i18n because of allowed transation (not yet supported in the new i18n service)
    case 'attachments': return offeredService?.attachments_title || i18nScoped.t('steps_title.attachments')
    case 'preferences': return i18nScoped.t('steps_title.preferences')
    case 'tasks': return i18nScoped.t('steps_title.tasks')
    case 'backoffice-custom-price': return i18nScoped.t('steps_title.backoffice_custom_price')
    case 'employee-quotation': return i18nScoped.t('steps_title.employee_quotation')
    case 'backoffice-appointment': return i18nScoped.t('steps_title.backoffice_appointment')
    case 'price': return i18nScoped.t('steps_title.price')
    case 'end-of-step-1': return null
    case 'end-of-step-2': return null
  }
}

type CastingStoreGetProgressForStepData = Pick<CastingStore['data'], 'market' | 'customer' | 'city' | 'cityResults' | 'offeredService' | 'castingType' | 'serviceCategory' | 'requiredPlace' | 'serviceDeliveryLocation' | 'calculatorResult' | 'serviceDelivery' | 'quantity' | 'backofficeFillServiceDelivery' | 'selectedOptions' | 'slots' | 'backofficeSelectAssignableForSlots' | 'asapOffer' | 'attachments' | 'selectedCombinationAttrs' | 'editedCastingId' | 'complexVariantMonoSlotMultiAllowedPatterns' | 'overrideRatePriceCents' | 'quotation' | 'lodging' | 'enableLodging' | 'lodgingIcalPlatform' | 'appointmentRequiredRanges' | 'groupSessionSchedule' | 'selectedQuantityDiscount' | 'customerPlanSubscriptionExpirationAction' | 'customerPlanSubscriptionRemovePendingId' | 'renderingMode'>
export function castingStoreGetProgressForStep (data: CastingStoreGetProgressForStepData, store: CastingStore, step: CastingStore['data']['focusedInput']): number {
  const { customer, city, cityResults, offeredService, castingType, serviceCategory, requiredPlace, overrideRatePriceCents, quotation } = data
  const { serviceDeliveryLocation, calculatorResult, serviceDelivery, quantity, backofficeFillServiceDelivery, selectedOptions, slots } = data
  const { lodging, enableLodging, lodgingIcalPlatform, appointmentRequiredRanges, selectedQuantityDiscount, renderingMode } = data
  const { customerPlanSubscriptionExpirationAction, customerPlanSubscriptionRemovePendingId } = data
  
  if (alwaysCompletedFocusedInputs.includes(step as any)) return 100

  switch(step as Exclude<typeof step, typeof alwaysCompletedFocusedInputs[0]>) {
    case 'end-of-step-2': return !castingStoreCanRenderCastingTypeInput(data) || castingType ? 100 : 0
    case 'backoffice-customer': return customer ? 100 : 0
    case 'city': return city ? 100 : (cityResults ? (cityResults.status === 'results' ? 50 : 25) : 0)
    case 'offered-service': {
      if (renderingMode === 'widget') return offeredService ? (castingType ? 100 : 50) : (serviceCategory ? 25 : 0)
      return offeredService ? 100 : (serviceCategory ? 50 : 0)
    }
    case 'enable-lodging': return enableLodging === null ? 0 : 100
    case 'lodging': {
      if (!lodging) return 0
      if ('id' in lodging) return 100

      let filledKeys = 0
      if (lodging.name) filledKeys++
      if (lodging.address_attributes.city) filledKeys++
      if (lodging.address_attributes.street) filledKeys++
      if (lodging.address_attributes.zipcode) filledKeys++
      if (lodging.address_attributes.country) filledKeys++
      return 100 * filledKeys / 5
    }
    case 'lodging-ical': 
      return lodging
        && !('id' in lodging) && lodging.ical_url
        && store.asyncComputedProperties.icalValidationError.readOrAsyncCompute([lodging.ical_url]) === 'valid'
        ? 100
        : (lodgingIcalPlatform ? 50 : 0)
    case 'lodging-check-in-out':
      return !lodging || 'id' in lodging
        ? 0
        : lodging.checkin_time && lodging.checkout_time
        ? 100
        : lodging.checkin_time || lodging.checkout_time
        ? 50
        : 0
    case 'required-place': return requiredPlace ? (requiredPlace !== 'on_site' || serviceDeliveryLocation ? 100 : 50) : 0
    case 'quantity': return quantity ? 100 : 0
    case 'duration': return calculatorResult ? 100 : 0
    case 'complex': return castingStoreGetProgressAndSummaryForFrequencyStep(data, store).progress
    case 'frequency': return castingStoreGetProgressAndSummaryForFrequencyStep(data, store).progress
    case 'start-date': return castingStoreGetProgressAndSummaryForStartDateStep(data).progress
    case 'end-date': return offeredService.enable_groups && !slots[0]?.end_date ? 0 : 100
    case 'attachments': return castingStoreGetProgressAndSummaryForAttachmentsStep(data).progress
    case 'combination-attributes': return castingStoreGetProgressAndSummaryForCombinationAttributesStep(data, 'combination-attributes').progress
    case 'combination-attributes-after-offered-service': return castingStoreGetProgressAndSummaryForCombinationAttributesStep(data, 'combination-attributes-after-offered-service').progress
    case 'group-session': return castingStoreGetProgressAndSummaryGroupSessionStep(data).progress
    case 'complex-variant': return castingStoreGetProgressAndSummaryComplexVariantStep(data).progress
    case 'backoffice-service-delivery': {
      if (!backofficeFillServiceDelivery) return 100
      const progressKeys = castingStoreGetServiceDeliveryRequiredKeys(data)
      return serviceDelivery ? Math.round((progressKeys.filter(key => serviceDelivery[key]).length / progressKeys.length) * 100) : 0
    }
    case 'backoffice-custom-price': return overrideRatePriceCents === null ? 0 : 100
    case 'employee-quotation':
      if (!quotation || !offeredService) return 0
      return quotationReadyForSubmit(quotation) ? 100 : 0
    case 'options': return (offeredService.require_at_least_one_selected_option && !selectedOptions.length) ? 0 : 100
    case 'backoffice-appointment': return appointmentRequiredRanges === null ? 100 : (appointmentRequiredRanges.length ? 100 : 50)
    case 'quantity-discount': return offeredService.require_selected_quantity_discount && !selectedQuantityDiscount ? 0 : 100
    case 'customer-plan': return !customerPlanSubscriptionExpirationAction && castingStoreGetExpiringCustomerPlanSubscription({ customer, offeredService, customerPlanSubscriptionRemovePendingId }).expiringSubscription ? 0 : 100
  }
}

type CastingStoreGetSummaryForStepData = Pick<CastingStore['data'], 'market' | 'customer' | 'offeredService' | 'coupon' | 'calculatorResult' | 'quantity' | 'slots' | 'selectedOptions' | 'serviceDelivery' | 'selectedItemPreferenceIds' | 'backofficeFillServiceDelivery' | 'city' | 'serviceCategory' | 'cityResults' | 'requiredPlace' | 'castingType' | 'serviceDeliveryLocation' | 'backofficeSelectAssignableForSlots' | 'asapOffer' | 'attachments' | 'selectedCombinationAttrs' | 'editedCastingId' | 'complexVariantMonoSlotMultiAllowedPatterns' | 'overrideRatePriceCents' | 'overrideRateTaxCents' | 'quotation' | 'lodging' | 'enableLodging' | 'lodgingIcalPlatform' | 'selectedQuantityDiscount' | 'appointmentRequiredRanges' | 'participantsNumber' | 'groupSessionSchedule' | 'customerPlan' | 'customerPlanSubscriptionExpirationAction' | 'customerPlanSubscriptionRemovePendingId' | 'renderingMode'>
export function castingStoreGetSummaryForStep (data: CastingStoreGetSummaryForStepData, store: CastingStore, step: CastingStore['data']['focusedInput']): string {
  const {
    customer, offeredService, coupon, calculatorResult, quantity, slots, selectedOptions, serviceDelivery, selectedItemPreferenceIds, backofficeFillServiceDelivery,
    quotation, enableLodging, lodgingIcalPlatform, selectedQuantityDiscount, appointmentRequiredRanges, customerPlan, customerPlanSubscriptionExpirationAction,
    customerPlanSubscriptionRemovePendingId
  } = data

  switch (step) {
    case 'backoffice-customer': return customer ? customer.full_name : '-'
    case 'lodging': return data.lodging ? (data.lodging.name || '-') : '-'
    case 'customer-plan': {
      if (customerPlanSubscriptionExpirationAction) return i18nScoped.t(`action_${customerPlanSubscriptionExpirationAction.expiration_action}`)
      if (customerPlan) return formatCustomerPlanNameAsString(customerPlan)

      const { expiringSubscription } = castingStoreGetExpiringCustomerPlanSubscription({ customer, offeredService, customerPlanSubscriptionRemovePendingId })
      if (expiringSubscription && !expiringSubscription.expiration_action) return i18nScoped.t('subscription_expiring_soon')

      const availableCustomerPlanSubscriptions = castingStoreAvailableCustomerPlanSubscriptions({ customer, offeredService })
      const pendingCustomerPlanSubscription = availableCustomerPlanSubscriptions.find(_ => !_.validated_at && _.id != customerPlanSubscriptionRemovePendingId)
      if (pendingCustomerPlanSubscription) return formatCustomerPlanNameAsString(pendingCustomerPlanSubscription.customer_plan)
      if (availableCustomerPlanSubscriptions.some(_ => _.validated_at)) return i18nScoped.t('already_subscribed')
      return '-'
    }
    case 'coupon': return coupon ? formatCouponNameAsString(coupon, false) : '-'
    case 'group-session': return castingStoreGetProgressAndSummaryGroupSessionStep(data).summaryMessages
    case 'complex-variant': return castingStoreGetProgressAndSummaryComplexVariantStep(data).summaryMessages ?? '-'
    case 'duration': return calculatorResult ? formatDurationFromSecs(calculatorResult) : '-'
    case 'quantity': return quantity ? `${quantity} x ${offeredService.name}` : '-'
    case 'complex': return castingStoreGetProgressAndSummaryForFrequencyStep(data, store).summaryMessages.join(', ')
    case 'frequency': return castingStoreGetProgressAndSummaryForFrequencyStep(data, store).summaryMessages.join(', ')
    case 'start-date': return castingStoreGetProgressAndSummaryForStartDateStep(data).summaryMessages
    case 'participants': return i18n('casting_steps.step_2.inputs.participants_number_input', data.participantsNumber) // Use the legacy i18n because of allowed transation (not yet supported in the new i18n service)
    case 'attachments': return castingStoreGetProgressAndSummaryForAttachmentsStep(data).summaryMessages || '-'
    case 'combination-attributes': return castingStoreGetProgressAndSummaryForCombinationAttributesStep(data, 'combination-attributes').summaryMessages || '-'
    case 'combination-attributes-after-offered-service': return castingStoreGetProgressAndSummaryForCombinationAttributesStep(data, 'combination-attributes-after-offered-service').summaryMessages || '-'
    case 'options': return i18nScoped.t('x_options_selected', { count: selectedOptions.length })
    case 'preferences': return toUpperCaseFirst(offeredService.preferences.flatMap(_ => _.item_preferences).filter(item => selectedItemPreferenceIds.includes(item.id)).map(item => item.name).join(', ')) || '-'
    case 'backoffice-service-delivery':
      if (serviceDelivery) return i18nScoped.t(castingStoreGetProgressForStep(data, store, 'backoffice-service-delivery') === 100 ? 'delivery_complete' : 'delivery_incomplete')
      if (!backofficeFillServiceDelivery) return i18nScoped.t('service_delivery_filled_by_customer')
      return '-'
    case 'backoffice-appointment': {
      if (appointmentRequiredRanges === null) return i18nScoped.t('do_not_provide_appointment_availabities')
      if (appointmentRequiredRanges.length) return i18nScoped.t('appointment_required_ranges_present')
      return i18nScoped.t('appointment_required_ranges_empty')
    }
    case 'end-date': {
      const endDate = slots.length > 0 && slots[0].end_date ? moment(slots[0].end_date) : null
      return endDate ? i18nScoped.t('until_date', { end_date: endDate.format('ll') }) : i18nScoped.t('no_end')
    }
    case 'backoffice-custom-price': {
      if (data.overrideRatePriceCents === null) return '-'
      
      const formattedWithoutTax = currencyWrapTaxNotice(currencyFormat(data.market.currency, (data.overrideRatePriceCents / 100).toFixed(2)), false)
      const formattedWithTax = currencyWrapTaxNotice(currencyFormat(data.market.currency, ((data.overrideRatePriceCents + data.overrideRateTaxCents) / 100).toFixed(2)), true)
      return i18nScoped.t(`override_price.${offeredService.rentable_unit_of_work}`, { without_tax: formattedWithoutTax, with_tax: formattedWithTax })
    }
    case 'employee-quotation': return quotation && quotationReadyForSubmit(quotation) ? i18nScoped.t('quotation_completed') : ''
    case 'lodging-ical': return i18nScoped.t('sync_from', { provider: lodgingIcalPlatform ? lodgingI18nIcalProvider(lodgingIcalPlatform) : '-' })
    case 'enable-lodging':
      if (enableLodging === null) return '-'
      return enableLodging ? i18nScoped.t('enable_lodging.on') : i18nScoped.t('enable_lodging.off')
    case 'lodging-check-in-out':
      if (!data.lodging || 'id' in data.lodging) return '-'
      if (!data.lodging.checkin_time && !data.lodging.checkout_time) return '-'
      return i18nScoped.t('check_in_out', { checkin_time: data.lodging.checkin_time, checkout_time: data.lodging.checkout_time })
    case 'quantity-discount': {
      if (!selectedQuantityDiscount) return '-'

      const formattedQuantity = offeredQuantityDiscountsI18nQuantityWithUnit(selectedQuantityDiscount.quantity_commitment, selectedQuantityDiscount.unit_of_work)
      return i18nScoped.t('selected_quantity_discount_summary', { quantity: formattedQuantity, discount: selectedQuantityDiscount.discount_percentage })
    }
    default: return ''
  }
}

type castingStoreGetProgressAndSummaryForFrequencyStepData = Pick<CastingStore['data'], 'market' | 'slots' | 'castingType' | 'offeredService' | 'backofficeSelectAssignableForSlots' |  'enableLodging'>
export function castingStoreGetProgressAndSummaryForFrequencyStep (data: castingStoreGetProgressAndSummaryForFrequencyStepData, store: CastingStore) {
  const { slots, castingType, offeredService, backofficeSelectAssignableForSlots } = data
  const allSlotHavePatterns = !slots.find(slot => !slot.allowed_patterns.filter(pattern => typeof pattern.day_id === 'number' && pattern.from_hour && pattern.until_hour).length)
  const checks: ('weeksInterval' | 'startDate' | 'dayIds' | 'allSlotHavePatterns' | 'backofficeSelectAssignableForSlots')[] = []
  
  // if rentable_unit_of_work === 'day', we do not ask any pattern and the complex more is disabled (so allowedPattern are set inside start_date)
  if (offeredService.rentable_unit_of_work !== 'day' && !offeredService.no_start_time_nor_duration_asked_to_customer) checks.push('allSlotHavePatterns')
  if (castingType === 'casting_recurring') checks.push('weeksInterval')
  if (castingStoreIsComplex(data)) checks.push('dayIds')
  if (backofficeSelectAssignableForSlots) checks.push('backofficeSelectAssignableForSlots')

  const checked = checks.filter(check => {
    switch(check) {
      case 'weeksInterval':
        return slots.length && slots[0].weeks_interval
      case 'startDate':
        return slots.length && slots[0].start_date
      case 'dayIds':
        return slots.find(slot => slot.allowed_patterns.find(pattern => typeof pattern.day_id === 'number'))
      case 'allSlotHavePatterns':
        return allSlotHavePatterns
      case 'backofficeSelectAssignableForSlots':
        return !slots.find(slot => !store.asyncComputedProperties.isAssignableAvailableForSlot.readOrAsyncCompute([slot, offeredService])?.available)
    }
  })

  const progress = Math.round(checked.length / checks.length * 100)
  const summaryMessages = checks.map(check => {
    if (check === 'weeksInterval') {
      return checked.includes(check) ? castingWeeksInterval(slots[0].weeks_interval) : ' - '
    } else if (check === 'dayIds') {
      if (!checked.includes(check)) return ' - '

      // use monday by default, so days are ordered by week day until the exact start date is known
      const monday = moment().day(1).toDate()
      const datifiedAllowedPatterns = slots
        .flatMap(slot => slot.allowed_patterns.map(allowedPattern => [slot, allowedPattern] as const))
        .map(([slot, pattern]) => [castingSlotAllowedPatternFirstDate(pattern.day_id, slot.start_date ?? monday), pattern] as const)

      const summary = utilGroupBy(datifiedAllowedPatterns, ([date]) => date.valueOf())
        .map(datifiedPatterns => [datifiedPatterns[0][0], datifiedPatterns.map(_ => _[1])] as const)
        .sort((a, b) => a[0].valueOf() - b[0].valueOf())
        .map(([date, patterns]) => {
          let formattedDate = date.format(castingType === 'casting_one_shot' ? 'ddd Do MMM' : 'ddd')

          if (castingStoreIsComplex(data) && patterns.length && patterns.every(_ => _.from_hour)) {
            formattedDate += ` (${patterns.map(_ => _.from_hour).filter(onlyUniqueByReference).sort().join(', ')})`
          }

          return formattedDate
        })
        .join(', ')

      return truncateString(summary, 65)
    }

    return null
  }).filter(_ => _)

  return { progress, summaryMessages }
}

type CastingStoreGetProgressAndSummaryForStartDateStepData = Pick<CastingStore['data'], 'market' | 'slots' | 'asapOffer' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreGetProgressAndSummaryForStartDateStep (data: CastingStoreGetProgressAndSummaryForStartDateStepData) {
  const { slots, asapOffer, offeredService, castingType, backofficeSelectAssignableForSlots, enableLodging } = data
  const startDate = slots.length > 0 && slots[0].start_date ? moment(slots[0].start_date) : null
  const startTime = slots.length > 0 && slots[0].allowed_patterns.length ? slots[0].allowed_patterns[0].from_hour : null
  const startDateAskedFirst = castingStoreAskStartEndDateBeforeComplex(data)

  // until_hour is set automatically unless customer_choose_end_date?
  const endTime = slots.length > 0 && slots[0].allowed_patterns.length ? slots[0].allowed_patterns[0].until_hour : null
  const missingAssignable = backofficeSelectAssignableForSlots && slots.find(slot => !slot.assignable?.id)
  const progress = !startDate
    ? 0
    : !enableLodging && !startDateAskedFirst && (!offeredService.no_start_time_nor_duration_asked_to_customer && !startTime)
    ? 25
    : !enableLodging && !startDateAskedFirst && (!offeredService.no_start_time_nor_duration_asked_to_customer && !endTime)
    ? 50
    : !startDateAskedFirst && missingAssignable
    ? 75
    : 100

  if (asapOffer) {
    var summaryMessages = i18nScoped.t('asap_within', { count: asapOffer })
  } else if (castingStoreIsComplex(data) || castingType === 'casting_recurring' || enableLodging) {
    summaryMessages = i18nScoped.t('formatted_date_from', { date: startDate?.format('ll') || '-' })
  } else if (offeredService.no_start_time_nor_duration_asked_to_customer && offeredService.flexible_start_date_in_absence_of_start_time_and_duration) {
    summaryMessages = i18nScoped.t('formatted_flexible_date', { date: startDate?.format('ll') || '-' })
  } else if (castingStoreIsAllowingAnyTime(data)) {
    summaryMessages = i18nScoped.t('allowing_any_date_and_time')
  } else if (offeredService.no_start_time_nor_duration_asked_to_customer) {
    summaryMessages = i18nScoped.t('formatted_date', { date: startDate?.format('ll') || '-' })
  } else if (offeredService.rentable_unit_of_work === 'day') {
    const endOfEvent = startDate && slots[0].duration && startDate.clone().add(slots[0].duration - 1, 'seconds')
    summaryMessages = i18nScoped.t('formatted_date_range', { start_date: startDate?.format('ll') || '-', end_date: endOfEvent?.format('ll') || '-' })
  } else {
    summaryMessages = i18nScoped.t('formatted_date_time', { date: startDate?.format('l') || '-', time: startTime || '-' })
  }

  return { progress, summaryMessages }
}

type CastingStoreGetProgressAndSummaryForAttachmentsStepData = Pick<CastingStore['data'], 'offeredService' | 'attachments' | 'editedCastingId'>
export function castingStoreGetProgressAndSummaryForAttachmentsStep (data: CastingStoreGetProgressAndSummaryForAttachmentsStepData) {
  const { offeredService: os, attachments } = data

  // attachments cannot be updated when the operator edits the casting.
  if (castingStoreIsEditingCasting(data)) return { progress: 100, summaryMessages: i18nScoped.t('attachments_cannot_be_updated'), counts: { loading: 0, success: 0, error: 0, missing: 0 } }

  const counts = attachments.reduce((acc, curr) => ({ ...acc, [curr.state]: acc[curr.state] + 1 }), { loading: 0, success: 0, error: 0, missing: 0 })
  counts.missing = Math.max(0, os.attachments_min_count - counts.success)
  const progress = counts.missing === 0 ? 100 : Math.round(counts.success / os.attachments_min_count * 100)
  const summaryMessages = (['success', 'error', 'loading'] as const)
    .filter(state => counts[state] > 0)
    .map(state => i18nScoped.t('loaded_attachments.' + state, { count: counts[state] }))
    .join(', ')
  
  return { progress, summaryMessages, counts }
}

type CastingStoreGetProgressAndSummaryForCombinationAttributesStep = Pick<CastingStore['data'], 'selectedCombinationAttrs' | 'offeredService'>
export function castingStoreGetProgressAndSummaryForCombinationAttributesStep (data: CastingStoreGetProgressAndSummaryForCombinationAttributesStep,step: 'combination-attributes' | 'combination-attributes-after-offered-service') {
  const { selectedCombinationAttrs, offeredService } = data
  if (!offeredService) return { progress: 0, summaryMessages: '' }

  const activeSelectedCombinationAttrs = selectedCombinationAttrs.filter(_ => !_._destroy)
  const allowedOfferedServiceAttrs = step === 'combination-attributes' ? castingStoreGetAllowedAttributesOfStep2(data) : castingStoreGetAllowedAttributeJustAfterOfferedService(data)
  const requiredAllowedAttrs = allowedOfferedServiceAttrs.filter(_ => _.required && !_.deactivated)
  const requiredFilledAllowedAttrs = requiredAllowedAttrs.filter(allowedAttr => activeSelectedCombinationAttrs.find(_ => _.allowed_offered_service_attr_id === allowedAttr.id))
  const progress = requiredAllowedAttrs.length ? Math.round(requiredFilledAllowedAttrs.length / requiredAllowedAttrs.length * 100) : 100

  const labeledChoices = activeSelectedCombinationAttrs
    .map(choice => ({ value: choice.value, allowedAttr: allowedOfferedServiceAttrs.find(_ => _.id === choice.allowed_offered_service_attr_id ) }))
    .filter(choice => !!choice.allowedAttr) // may be undefined because allowedAttr from other steps are excluded
    .map(choice => `${ choice.allowedAttr.offered_service_attr.name }: ${ choice.value }`)

  return { progress, summaryMessages: utilFormatWordsListWithLimit(labeledChoices, 2), missing: requiredAllowedAttrs.length - requiredFilledAllowedAttrs.length }
}

type CastingStoreGetProgressAndSummaryComplexVariantStepData = Pick<CastingStore['data'], 'complexVariantMonoSlotMultiAllowedPatterns'>
export function castingStoreGetProgressAndSummaryComplexVariantStep (data: CastingStoreGetProgressAndSummaryComplexVariantStepData) {
  if (data.complexVariantMonoSlotMultiAllowedPatterns === null) {
    return { progress: 0, summaryMessages: '' }
  }

  return { progress: 100, summaryMessages: i18nScoped.t(`complex_variant.${data.complexVariantMonoSlotMultiAllowedPatterns ? 'mono_slot' : 'multi_slots'}`) }
}

type CastingStoreGetProgressAndSummaryGroupSessionStepData = Pick<CastingStore['data'], 'slots' | 'groupSessionSchedule'>
export function castingStoreGetProgressAndSummaryGroupSessionStep (data: CastingStoreGetProgressAndSummaryGroupSessionStepData) {
  const { slots, groupSessionSchedule } = data

  // Progress calculation: 0 = no start_date, 50 = start_date but no schedule, 100 = schedule selected
  if (!slots[0]?.start_date) return { progress: 0, summaryMessages: '-' }
  
  if (!groupSessionSchedule) {
    const summaryMessages = `${moment(slots[0].start_date).format('ll')} - ${i18nScoped.t('missing_time')}`
    return { progress: 50, summaryMessages }
  }

  // When schedule is selected, show date and time + frequency
  const startTime = slots[0].allowed_patterns[0]?.from_hour || ''
  let summaryMessages = `${moment(slots[0].start_date).format('ll')} ${startTime}`
  if (slots[0].weeks_interval) summaryMessages += ` - ${ scheduleI18nIntervalFrequency(slots[0].weeks_interval, 'weekly', { capitalize: false }) }`
  return { progress: 100, summaryMessages }
}

type CastingStoreGetFocusedInputInLegacyStepData = Pick<CastingStore['data'], 'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'backofficeSetCustomPriceWithoutQuotation' | 'enableLodging' | 'lodging' | 'coupon' | 'promotionalCode' | 'serviceDeliveryLocation' | 'requiredPlace' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'customerPlan'>
export function castingStoreGetFocusedInputInLegacyStep (data: CastingStoreGetFocusedInputInLegacyStepData, step: 1 | 2 | 3, iterationMethod = castingStoreGetNextActivableFocus.bind(null, data)) {
  const firstFocusedInputPerStep: { [step: number]: CastingStore['data']['focusedInput'] } = { 1: 'backoffice-customer', 2: 'end-of-step-1', 3: 'end-of-step-2' }
  const focusedInputs: CastingStore['data']['focusedInput'][] = []
  for (let focus = firstFocusedInputPerStep[step]; focus && focus !== firstFocusedInputPerStep[step + 1]; focus = iterationMethod(focus)) focusedInputs.push(focus)
  return focusedInputs
}

type CastingStoreGetLegacyStepOfFocusedInputData = Pick<CastingStore['data'], 'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'backofficeSetCustomPriceWithoutQuotation' | 'enableLodging' | 'lodging' | 'coupon' | 'promotionalCode' | 'serviceDeliveryLocation' | 'requiredPlace' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'customerPlan'>
export function castingStoreGetLegacyStepOfFocusedInput (data: CastingStoreGetLegacyStepOfFocusedInputData, focusedInput: CastingStore['data']['focusedInput'], iterationMethod = castingStoreGetNextActivableFocus.bind(null, data)): 1 | 2 | 3 {
  for (const legacyStep of [1, 2, 3] as const) {
    if (castingStoreGetFocusedInputInLegacyStep(data, legacyStep, iterationMethod).includes(focusedInput)) return legacyStep
  }

  return null
}

type CastingStoreValidatesLegacyCastingStepData = Pick<CastingStore['data'],  'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'quantity' | 'cityResults' | 'serviceCategory' | 'requiredPlace' | 'serviceDeliveryLocation' | 'calculatorResult' | 'serviceDelivery' | 'selectedOptions' | 'attachments' | 'asapOffer' | 'selectedCombinationAttrs' | 'complexVariantMonoSlotMultiAllowedPatterns' | 'backofficeSetCustomPriceWithoutQuotation' | 'overrideRatePriceCents' | 'quotation' | 'lodging' | 'enableLodging' | 'lodgingIcalPlatform' | 'coupon' | 'promotionalCode' | 'appointmentRequiredRanges' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'selectedQuantityDiscount' | 'customerPlan' | 'customerPlanSubscriptionExpirationAction' | 'customerPlanSubscriptionRemovePendingId'>
export function castingStoreValidatesLegacyCastingStep (data: CastingStoreValidatesLegacyCastingStepData, store: CastingStore, step: 1 | 2) {
  const allFocusedStepsOk = !castingStoreGetFocusedInputInLegacyStep(data, step)
    .find(focusedInput => castingStoreCanFocus(data, focusedInput) && castingStoreGetProgressForStep(data, store, focusedInput) !== 100)

  // On desktop, the casting type is asked in step2 and not validated by any focusedInput
  return allFocusedStepsOk && (step != 2 || !!data.castingType || !castingStoreCanRenderCastingTypeInput(data))
}

type CastingStoreGetPricedEventsData = Pick<CastingStore['data'], 'city' | 'offeredService' | 'castingType' | 'serviceDeliveryLocation' | 'slots' | 'selectedCombinationAttrs' | 'selectedOptions' | 'calculatorResult' | 'calculatorResultFirstEvent' | 'overrideRatePriceCents' | 'overrideRateTaxCents' | 'customer' | 'market'>
export function castingStoreGetPricedEvents (data: CastingStoreGetPricedEventsData, store: CastingStore, lazy = false) {
  // This method should not be called in the context of a buyable product
  if (!data.offeredService?.rentable) return null

  // When quotation is enabled, no price should be displayed in the UI
  if (data.offeredService?.casting_custom_price && data.overrideRatePriceCents === null) return null

  // When the casting is invoiced on a month basis (fixed price per month, no matter how many events there are),
  // it is not relevant to compute the price of the events. In fact, another method should be called in such case.
  if (data.offeredService?.rentable_unit_of_work === 'month') return null

  return store.asyncComputedProperties.pricedEvents.readOrAsyncCompute([
    castingStoreDisplayPriceWithTax(data),
    data.city,
    data.offeredService,
    data.castingType,
    data.serviceDeliveryLocation,
    data.slots,
    data.selectedCombinationAttrs,
    data.selectedOptions,
    castingStoreGetMinDurationForFirstEvent(data),
    data.overrideRatePriceCents,
    data.overrideRateTaxCents
  ], lazy)
}

export function castingStoreGetTotalPrice (data: CastingStoreGetPricedEventsData, store: CastingStore, lazy = false) {
  return store.asyncComputedProperties.totalPrice.readOrAsyncCompute([
    castingStoreDisplayPriceWithTax(data),
    data.city,
    data.offeredService,
    data.castingType,
    data.serviceDeliveryLocation,
    data.slots,
    data.selectedCombinationAttrs,
    data.selectedOptions,
    castingStoreGetMinDurationForFirstEvent(data),
    data.overrideRatePriceCents,
    data.overrideRateTaxCents
  ], lazy)
}

type CastingStoreGetRealTimeAvailabilitiesData = Pick<CastingStore['data'], 'city' | 'offeredService' | 'castingType' | 'slots' | 'requiredPlace' | 'serviceDeliveryLocation' | 'enableLodging' | 'requiredEmployees'>
export function castingStoreGetRealTimeAvailabilities ({ city, offeredService, castingType, slots, requiredPlace, serviceDeliveryLocation, enableLodging, requiredEmployees }: CastingStoreGetRealTimeAvailabilitiesData, store: CastingStore) {
  if (!city || !offeredService || !requiredPlace) return []

  // weeksInterval may be not yet known, and we take the most realistic value in that case (so the cache will be ready if that value is picked)
  const weeksInterval = castingType === 'casting_recurring' ? (slots.length && slots[0].weeks_interval) || 1 : null
  return store.asyncComputedProperties.realTimeAvailabilities.readOrAsyncCompute([city, offeredService, castingType, weeksInterval, requiredPlace, serviceDeliveryLocation?.id, enableLodging, requiredEmployees])
}

type CastingStoreHasRealTimeAvailabilityAtTimeData = Pick<CastingStore['data'], 'city' | 'offeredService' | 'castingType' | 'slots' | 'requiredPlace' | 'serviceDeliveryLocation' | 'enableLodging' | 'requiredEmployees'>
export function castingStoreHasRealTimeAvailabilityAtTime (data: CastingStoreHasRealTimeAvailabilityAtTimeData, store: CastingStore, datetime: moment.Moment | Date, minDurationInSeconds: number) {
  const realTimeAvailabilities = castingStoreGetRealTimeAvailabilities(data, store)

  // realtime availabilities are not yet loaded (XHR probably pending, any other reason is probably a bug).
  if (!realTimeAvailabilities) return false

  for (const rtForOneAssignable of realTimeAvailabilities) {
    const found = rtForOneAssignable.find(range => range.contains(datetime) && moment(range.end).diff(datetime, 'seconds') >= minDurationInSeconds)
    if (found) return true
  }

  return false
}

type CastingStoreBuildAvailableBodyForSlotData = Pick<CastingStore['data'], 'offeredService'>
export function castingStoreBuildAvailableBodyForSlot ({ offeredService }: CastingStoreBuildAvailableBodyForSlotData, slot: StoreProps['data']['slots'][0]) {
  // the HTTP endpoint is not designed for checking multiples days with breaks due to multi_opening_hours... so we just do not filter by availability
  if (offeredService.rentable_unit_of_work === 'day') return undefined

  const body: EmployeeRansackQuery['available_for'] = {
    datetime: castingUnserializeSlot({ ...slot, start_date: slot.start_date || moment().format('YYYY-MM-DD') }).allowed_patterns[0].from_hour.format('YYYY-MM-DD HH:mm:ss'),
    duration: slot.duration,
    schedule_type: 'service_delivery'
  }

  if (slot.weeks_interval) {
    body.weeks_interval = slot.weeks_interval
    body.frequency = 'weekly'
    body.recurring_until = slot.end_date
  }

  return body
}

type CastingStoreWillBroadcastIfCreatedByOperatorData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'editedCastingId'>
export function castingStoreWillBroadcastIfCreatedByOperator (data: CastingStoreWillBroadcastIfCreatedByOperatorData) {
  // Basic conditions about the broadcast being enabled.
  if (!data.offeredService.broadcast_casting || !data.market['broadcast_casting?']) return false

  // No broadcast is triggered at casting creation if a confirmation is required before broadcast.
  if (data.offeredService.casting_review_before_broadcast) return false

  // Broadcast only happens when the operator creates the casting.
  if (data.editedCastingId || window.currentUser?.type !== 'Operator') return false

  // As for now, only castings created by suppliers (with their own offered_service) are supported by the current implementation (which to not looks for offered_service_subscriptions, etc.).
  if (data.market.market_type !== 'Supplier') return false

  // The backend triggers a broadcast in NewCastingJob, which is enqueued in casting#compute_casting or in casting_manager#create.
  // The condition for NewCastingJob being called in casting#compute_casting is that the casting is indirect (the case if serviceDelivery form is not fulfilled).
  // The condition for NewCastingJob being called in casting_manager#create is that the casting is direct, but not immediately finalized.
  // Since the casting becomes direct when the serviceDelivery form is fulfilled, but only employees can immediately finalize a casting via casting_manager#create,
  // the broadcast will be tried no matter what.
  return true
}

type CastingStoreFinalizeSlotsBeforeSubmitData = Pick<CastingStore['data'], 'offeredService' | 'slots' | 'castingType' | 'calculatorResult' | 'calculatorResultFirstEvent' | 'selectedOptions' | 'groupSessionSchedule'>

/**
 * - apply options adding duration to each slot.
 * - compute end date based on the prescritper plans.
 */
export function castingStoreFinalizeSlotsBeforeSubmit (data: CastingStoreFinalizeSlotsBeforeSubmitData) {
  // do not try to touch slot duration when no duration was input in the first place.
  if (data.offeredService.no_start_time_nor_duration_asked_to_customer) return data.slots

  const slots: CastingSlot[] = JSON.parse(JSON.stringify(data.slots))
  for (const slot of slots) slot.duration *= slot.employees_count || 1
  const minDurationFirstEvent = castingStoreGetMinDurationForFirstEvent(data)

  const firstSlotByDate = slots.slice().sort((aSlot, bSlot) => {
    // castingUnserializeSlot requires a start date to be given, but some process may leave it nil.
    // Ex. creating a recurring quotation using QuotationBeforeCastingSetScheduleSlotsModalComponent.
    // => in that case, we rely on slot.day_id for the most natural sorting possible (anyway, sorting is for convenience).
    aSlot = { ...aSlot, start_date: aSlot.start_date || moment().day(1).format('YYYY-MM-DD') }
    bSlot = { ...bSlot, start_date: bSlot.start_date || moment().day(1).format('YYYY-MM-DD') }

    const aDate = moment.min(...castingUnserializeSlot(aSlot).allowed_patterns.map(_ => _.from_hour))
    const bDate = moment.min(...castingUnserializeSlot(bSlot).allowed_patterns.map(_ => _.from_hour))
    return aDate.valueOf() - bDate.valueOf()
  })[0]

  if (slots.length && minDurationFirstEvent && firstSlotByDate.duration < minDurationFirstEvent) {
    const durationToAddToFirstEvent = minDurationFirstEvent - firstSlotByDate.duration

    if (firstSlotByDate.weeks_interval) {
      // the first slot lasts longer than the rest of the reccurrence
      slots.unshift(...castingExtendsAllowedPatternOnDurationChanged([{ ...firstSlotByDate, weeks_interval: null }], durationToAddToFirstEvent))
      firstSlotByDate.start_date = moment(firstSlotByDate.start_date).add(firstSlotByDate.weeks_interval, 'week').format('YYYY-MM-DD')
    } else {
      // in case of complex oneshot, multiple slots may exist: only the first by date and allowed pattern should be patched
      Object.assign(firstSlotByDate, castingExtendsAllowedPatternOnDurationChanged([firstSlotByDate], durationToAddToFirstEvent)[0])
    }
  }

  // set the recurrence end_date before submitting in case of prescriber funded hours
  const prescriberRemainingFundedHours = castingStoreGetPrescriberRemainingFundedHours(data)

  if (typeof prescriberRemainingFundedHours === 'number' && slots.some(_ => typeof _.weeks_interval === 'number')) {
    const endDate = castingStoreSimulateOccurrencesUpToMaxAllowedDuration(
      data,
      prescriberRemainingFundedHours,
      { end_date: slots[0].end_date || castingStoreGetMaxRecurrenceEndDate(data).add(1, 'day').format('YYYY-MM-DD') }
    ).pop().at.add(1, 'day').format('YYYY-MM-DD')

    for (const slot of slots) slot.end_date = endDate
  }

  // apply options adding duration to each slot.
  return castingExtendsAllowedPatternOnDurationChanged(slots, castingStoreGetSelectedOptionDurationPerSlot(data))
}

type CastingStoreIsEditingCastingData = Pick<CastingStore['data'], 'editedCastingId'>
export function castingStoreIsEditingCasting (data: CastingStoreIsEditingCastingData) {
  return !!data.editedCastingId
}

export function castingStoreToJson (data: CastingStore['data']) {
  const pendingCustomerPlanSubscription = castingStoreAvailableCustomerPlanSubscriptions(data)?.find(_ => !_.validated_at && _.id != data.customerPlanSubscriptionRemovePendingId)

  return {
    casting: {
      id: data.editedCastingId,
      city: data.city.city,
      zipcode: data.city.postalCode,
      latitude: data.city.lat,
      longitude: data.city.lng,
      slots: castingStoreFinalizeSlotsBeforeSubmit(data),
      quantity: data.quantity,
      required_place: data.requiredPlace,
      service_delivery_location_id: data.serviceDeliveryLocation?.id,
      offered_service_id: data.offeredService.id,
      selected_options_attributes: data.selectedOptions,
      item_preference_ids: data.selectedItemPreferenceIds,
      item_task_ids: data.selectedTaskItemIds,
      variable_metier: data.variableMetier,
      selected_duration_calculator_items_attributes: data.selectedDurationCalculatorItems.filter(_ => _.id || _.quantity).map(_ => !_.quantity ? { ..._, _destroy: true } : _),
      participants_number: data.participantsNumber || undefined,
      asap_offer: data.asapOffer,
      message: data.message,
      presence_of_pets: data.pets,
      urssaf_payment: data.urssafPayment,
      customer_id: data.customer?.id,
      promotional_code_id: data.promotionalCode?.id,
      required_supplier_id: data.requiredSupplier?.id,
      required_employee_ids: data.requiredEmployees.map(_ => _.id),
      bought_coupons_pack_attributes: data.coupon ? { coupons_pack_id: data.coupon.id } : null,
      castings_prescriber_casting_fundings_attributes: castingStoreGetPrescriberCastingFundings(data).map(funding => ({ prescriber_casting_funding_id: funding.id })),
      selected_combination_attrs_attributes: data.selectedCombinationAttrs,
      attachments_from_cached_uuid: data.editedCastingId ? undefined : data.attachments.filter(_ => _.uuid).map(_ => _.uuid),
      additional_data: !data.additionalData || !Object.keys(data.additionalData).length ? undefined : data.additionalData,
      accept_gdpr_campaigns: data.hasAcceptedGdprCampaigns,
      override_rate_price_cents: data.overrideRatePriceCents ?? undefined,
      override_rate_tax_cents: data.overrideRateTaxCents ?? undefined,
      skip_broadcast_on_create: data.skipBroadcastOnCreate,
      quotation_attributes: data.quotation ?? undefined,
      lodging_attributes: data.lodging && !('id' in data.lodging) ? data.lodging : undefined,
      lodging_id: data.lodging && 'id' in data.lodging ? data.lodging.id : undefined,
      appointment_required_ranges: data.appointmentRequiredRanges,
      process_pending_customer_plan_subscriptions_on_finalize: !!data.customerPlan || !!pendingCustomerPlanSubscription,
      customer_plan_id: data.customerPlan?.id,
      customer_plan_subscription_attributes: data.customerPlanSubscriptionRemovePendingId ? { id: data.customerPlanSubscriptionRemovePendingId, _destroy: true } : undefined,
      process_pending_selected_quantity_discount_on_finalize: !!data.selectedQuantityDiscount,
      offered_quantity_discount_id: data.selectedQuantityDiscount?.offered_quantity_discount_id,
      selected_quantity_discount_attributes: data.offeredService.selected_quantity_discount_for_customer && !data.selectedQuantityDiscount?.id ? { id: data.offeredService.selected_quantity_discount_for_customer.id, _destroy: true } : undefined,
      group_session_schedule_id: data.groupSessionSchedule?.id || null
    },
    service_delivery: data.serviceDelivery,
    employees_for_slots_ids: data.backofficeSelectAssignableForSlots
      ? data.slots.map(slot => data.offeredService.offered_service_type === 'offered_service' ? slot.assignable?.id : null)
      : undefined,
    offered_service_resources_for_slots_ids: data.backofficeSelectAssignableForSlots
      ? data.slots.map(slot => data.offeredService.offered_service_type === 'product' ? slot.assignable?.id : null)
      : undefined
  }
}

export function castingStoreToDraftJson (data: CastingStore['data']) {
  const slots = castingStorePreparePendingSlotsForSimulation(data)
  return castingStoreToJson({ ...data, slots })
}

type CastingStorePersistCustomerPlanExpirationActionData = Pick<CastingStore['data'], 'customerPlanSubscriptionExpirationAction'>
export async function castingStorePersistCustomerPlanExpirationAction (data: CastingStorePersistCustomerPlanExpirationActionData) {
  if (!data.customerPlanSubscriptionExpirationAction) return

  await customerPlanSubscriptionUpdateExpirationAction(data.customerPlanSubscriptionExpirationAction.id, data.customerPlanSubscriptionExpirationAction.expiration_action)
    .catch(() => { throw { errors: {}, full_messages: [i18nScoped.t('failed_to_update_plan_expiration_preference')] } })
}

type CastingStoreGetNextActivableFocusData = Pick<CastingStore['data'], 'market' | 'editedCastingId' | 'renderingMode' | 'backofficeSelectCustomer' | 'backofficeFillServiceDelivery' | 'backofficeSelectAssignableForSlots' | 'employeeAlreadyWorkedForSelectedCustomer' | 'city' | 'offeredService' | 'castingType' | 'slots' | 'customer' | 'backofficeSetCustomPriceWithoutQuotation' | 'enableLodging' | 'lodging' | 'coupon' | 'promotionalCode' | 'serviceDeliveryLocation' | 'requiredPlace' | 'groupSessionSchedule' | 'focusedInputBlacklist' | 'customerPlan'>
export function castingStoreGetNextActivableFocus (data: CastingStoreGetNextActivableFocusData, currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
  const nextFocus = castingStoreGetNextFocus(data, currentFocus)
  if (!nextFocus) return null
  if (castingStoreCanFocus(data, nextFocus)) return nextFocus
  return castingStoreGetNextActivableFocus(data, nextFocus)
}

export function castingStoreGetPreviousActivableFocus (data: CastingStoreGetNextActivableFocusData, currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
  if (!currentFocus) return null
  const previousFocus = castingStoreGetPreviousFocus(data, currentFocus)
  if (!previousFocus) return null
  if (castingStoreCanFocus(data, previousFocus)) return previousFocus
  return castingStoreGetPreviousActivableFocus(data, previousFocus)
}

type CastingStoreHasDayOffAtDateData = Pick<CastingStore['data'], 'market' | 'offeredService'>
export function castingStoreHasDayOffAtDate ({ offeredService, market }: CastingStoreHasDayOffAtDateData, date: Date) {
  return (offeredService.dont_work_on_day_off ?? market.dont_work_on_day_off) && market.day_offs.some(_ => moment(_.date).isSame(date, 'day'))
}

type CastingStoreAskStartEndDateBeforeComplexData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreAskStartEndDateBeforeComplex (data: CastingStoreAskStartEndDateBeforeComplexData): boolean {
  return data.backofficeSelectAssignableForSlots && window.currentUser?.type === 'Operator' && castingStoreIsComplex(data)
}                                                                                                                                                                                                      
                                                                                                                                                                                                       
type CastingStoreGetOrderedFocusedInputsData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreGetOrderedFocusedInputs (data: CastingStoreGetOrderedFocusedInputsData) {
  const startEndDateFirst = castingStoreAskStartEndDateBeforeComplex(data)

  return [
    'backoffice-customer',
    'city',
    'offered-service',
    'combination-attributes-after-offered-service',
    'preferences',
    'enable-lodging',
    'lodging',
    'required-place',
    'end-of-step-1',
    'combination-attributes',
    'quantity',
    'customer-plan',
    'coupon',
    'quantity-discount',
    'group-session',
    'complex-variant',
    'duration',
    ...(startEndDateFirst ? ['start-date', 'end-date'] as const : []),
    'complex',
    'frequency',
    ...(!startEndDateFirst ? ['start-date', 'end-date'] as const : []),
    'lodging-ical',
    'lodging-check-in-out',
    'backoffice-appointment',
    'participants',
    'attachments',
    'tasks',
    'options',
    'message',
    'end-of-step-2',
    'backoffice-service-delivery',
    'backoffice-custom-price',
    'employee-quotation'
  ] satisfies CastingStore['data']['focusedInput'][]
}

type CastingStoreGetNextFocusData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreGetNextFocus (data: CastingStoreGetNextFocusData, currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
  const orderedSteps = castingStoreGetOrderedFocusedInputs(data)

  if (currentFocus == 'price' || currentFocus == orderedSteps[orderedSteps.length - 1]) return null

  const index = orderedSteps.indexOf(currentFocus)
  return orderedSteps[index + 1]
}

type CastingStoreGetPreviousFocusData = Pick<CastingStore['data'], 'market' | 'offeredService' | 'castingType' | 'backofficeSelectAssignableForSlots' | 'enableLodging'>
export function castingStoreGetPreviousFocus (data: CastingStoreGetPreviousFocusData, currentFocus: CastingStore['data']['focusedInput']): CastingStore['data']['focusedInput'] {
  for (const focusedInput of focusedInputs) {
    if (castingStoreGetNextFocus(data, focusedInput) === currentFocus) return focusedInput
  }

  return null
}
